export default {
  2014: {
    areas: [
      {
        id: "AF",
        value: 19880820,
        tooltip: '<span style="font-weight:bold;">Afghanistan</span><br />Population : 19880820',
      },
      {
        id: "ZA",
        value: 25183856,
        tooltip: '<span style="font-weight:bold;">South Africa</span><br />Population : 25183856',
      },
      {
        id: "AL",
        value: 51947647,
        tooltip: '<span style="font-weight:bold;">Albania</span><br />Population : 51947647',
      },
      {
        id: "DZ",
        value: 25677417,
        tooltip: '<span style="font-weight:bold;">Algeria</span><br />Population : 25677417',
      },
      {
        id: "DE",
        value: 17767648,
        tooltip: '<span style="font-weight:bold;">Germany</span><br />Population : 17767648',
      },
      {
        id: "AD",
        value: 8241925,
        tooltip: '<span style="font-weight:bold;">Andorra</span><br />Population : 8241925',
      },
      {
        id: "AO",
        value: 20995901,
        tooltip: '<span style="font-weight:bold;">Angola</span><br />Population : 20995901',
      },
      {
        id: "AG",
        value: 10080896,
        tooltip: '<span style="font-weight:bold;">Antigua And Barbuda</span><br />Population : 10080896',
      },
      {
        id: "SA",
        value: 43615610,
        tooltip: '<span style="font-weight:bold;">Saudi Arabia</span><br />Population : 43615610',
      },
      {
        id: "AR",
        value: 44063471,
        tooltip: '<span style="font-weight:bold;">Argentina</span><br />Population : 44063471',
      },
      {
        id: "AM",
        value: 50763102,
        tooltip: '<span style="font-weight:bold;">Armenia</span><br />Population : 50763102',
      },
      {
        id: "AU",
        value: 23849414,
        tooltip: '<span style="font-weight:bold;">Australia</span><br />Population : 23849414',
      },
      {
        id: "AT",
        value: 35652829,
        tooltip: '<span style="font-weight:bold;">Austria</span><br />Population : 35652829',
      },
      {
        id: "AZ",
        value: 48414118,
        tooltip: '<span style="font-weight:bold;">Azerbaijan</span><br />Population : 48414118',
      },
      {
        id: "BS",
        value: 4602371,
        tooltip: '<span style="font-weight:bold;">Bahamas</span><br />Population : 4602371',
      },
      {
        id: "BH",
        value: 27673596,
        tooltip: '<span style="font-weight:bold;">Bahrain</span><br />Population : 27673596',
      },
      {
        id: "BD",
        value: 21957431,
        tooltip: '<span style="font-weight:bold;">Bangladesh</span><br />Population : 21957431',
      },
      {
        id: "BB",
        value: 26909491,
        tooltip: '<span style="font-weight:bold;">Barbados</span><br />Population : 26909491',
      },
      {
        id: "BE",
        value: 15416836,
        tooltip: '<span style="font-weight:bold;">Belgium</span><br />Population : 15416836',
      },
      {
        id: "BZ",
        value: 12194067,
        tooltip: '<span style="font-weight:bold;">Belize</span><br />Population : 12194067',
      },
      {
        id: "BJ",
        value: 657540,
        tooltip: '<span style="font-weight:bold;">Benin</span><br />Population : 657540',
      },
      {
        id: "BT",
        value: 15115216,
        tooltip: '<span style="font-weight:bold;">Bhutan</span><br />Population : 15115216',
      },
      {
        id: "BY",
        value: 6459622,
        tooltip: '<span style="font-weight:bold;">Belarus</span><br />Population : 6459622',
      },
      {
        id: "MM",
        value: 57901453,
        tooltip: '<span style="font-weight:bold;">Myanmar</span><br />Population : 57901453',
      },
      {
        id: "BO",
        value: 59731284,
        tooltip: '<span style="font-weight:bold;">Bolivia, Plurinational State Of</span><br />Population : 59731284',
      },
      {
        id: "BA",
        value: 18646918,
        tooltip: '<span style="font-weight:bold;">Bosnia And Herzegovina</span><br />Population : 18646918',
      },
      {
        id: "BW",
        value: 50733853,
        tooltip: '<span style="font-weight:bold;">Botswana</span><br />Population : 50733853',
      },
      {
        id: "BR",
        value: 35636377,
        tooltip: '<span style="font-weight:bold;">Brazil</span><br />Population : 35636377',
      },
      {
        id: "BN",
        value: 17606784,
        tooltip: '<span style="font-weight:bold;">Brunei Darussalam</span><br />Population : 17606784',
      },
      {
        id: "BG",
        value: 13170221,
        tooltip: '<span style="font-weight:bold;">Bulgaria</span><br />Population : 13170221',
      },
      {
        id: "BF",
        value: 11592654,
        tooltip: '<span style="font-weight:bold;">Burkina Faso</span><br />Population : 11592654',
      },
      {
        id: "BI",
        value: 25889465,
        tooltip: '<span style="font-weight:bold;">Burundi</span><br />Population : 25889465',
      },
      {
        id: "KH",
        value: 22162167,
        tooltip: '<span style="font-weight:bold;">Cambodia</span><br />Population : 22162167',
      },
      {
        id: "CM",
        value: 4300750,
        tooltip: '<span style="font-weight:bold;">Cameroon</span><br />Population : 4300750',
      },
      {
        id: "CA",
        value: 21939151,
        tooltip: '<span style="font-weight:bold;">Canada</span><br />Population : 21939151',
      },
      {
        id: "CV",
        value: 19301343,
        tooltip: '<span style="font-weight:bold;">Cape Verde</span><br />Population : 19301343',
      },
      {
        id: "CF",
        value: 11625558,
        tooltip: '<span style="font-weight:bold;">Central African Republic</span><br />Population : 11625558',
      },
      {
        id: "CL",
        value: 27604132,
        tooltip: '<span style="font-weight:bold;">Chile</span><br />Population : 27604132',
      },
      {
        id: "CN",
        value: 5026467,
        tooltip: '<span style="font-weight:bold;">China</span><br />Population : 5026467',
      },
      {
        id: "CY",
        value: 36462634,
        tooltip: '<span style="font-weight:bold;">Cyprus</span><br />Population : 36462634',
      },
      {
        id: "CO",
        value: 14075082,
        tooltip: '<span style="font-weight:bold;">Colombia</span><br />Population : 14075082',
      },
      {
        id: "KM",
        value: 28795990,
        tooltip: '<span style="font-weight:bold;">Comoros</span><br />Population : 28795990',
      },
      {
        id: "CG",
        value: 33857730,
        tooltip: '<span style="font-weight:bold;">Congo</span><br />Population : 33857730',
      },
      {
        id: "CD",
        value: 8113964,
        tooltip: '<span style="font-weight:bold;">Congo, The Democratic Republic Of The</span><br />Population : 8113964',
      },
      {
        id: "KP",
        value: 27638864,
        tooltip: "<span style=\"font-weight:bold;\">Korea, Democratic People's Republic Of</span><br />Population : 27638864",
      },
      {
        id: "KR",
        value: 43441950,
        tooltip: '<span style="font-weight:bold;">Korea, Republic Of</span><br />Population : 43441950',
      },
      {
        id: "CR",
        value: 31686063,
        tooltip: '<span style="font-weight:bold;">Costa Rica</span><br />Population : 31686063',
      },
      {
        id: "CI",
        value: 14745959,
        tooltip: "<span style=\"font-weight:bold;\">C\u00d4te D'ivoire</span><br />Population : 14745959",
      },
      {
        id: "HR",
        value: 20495029,
        tooltip: '<span style="font-weight:bold;">Croatia</span><br />Population : 20495029',
      },
      {
        id: "CU",
        value: 17257635,
        tooltip: '<span style="font-weight:bold;">Cuba</span><br />Population : 17257635',
      },
      {
        id: "DK",
        value: 11614590,
        tooltip: '<span style="font-weight:bold;">Denmark</span><br />Population : 11614590',
      },
      {
        id: "DJ",
        value: 46999243,
        tooltip: '<span style="font-weight:bold;">Djibouti</span><br />Population : 46999243',
      },
      {
        id: "DM",
        value: 50671701,
        tooltip: '<span style="font-weight:bold;">Dominica</span><br />Population : 50671701',
      },
      {
        id: "EG",
        value: 45708673,
        tooltip: '<span style="font-weight:bold;">Egypt</span><br />Population : 45708673',
      },
      {
        id: "AE",
        value: 16696438,
        tooltip: '<span style="font-weight:bold;">United Arab Emirates</span><br />Population : 16696438',
      },
      {
        id: "EC",
        value: 5664441,
        tooltip: '<span style="font-weight:bold;">Ecuador</span><br />Population : 5664441',
      },
      {
        id: "ER",
        value: 26447006,
        tooltip: '<span style="font-weight:bold;">Eritrea</span><br />Population : 26447006',
      },
      {
        id: "ES",
        value: 14610687,
        tooltip: '<span style="font-weight:bold;">Spain</span><br />Population : 14610687',
      },
      {
        id: "EE",
        value: 134732,
        tooltip: '<span style="font-weight:bold;">Estonia</span><br />Population : 134732',
      },
      {
        id: "US",
        value: 1182177,
        tooltip: '<span style="font-weight:bold;">United States</span><br />Population : 1182177',
      },
      {
        id: "ET",
        value: 5849069,
        tooltip: '<span style="font-weight:bold;">Ethiopia</span><br />Population : 5849069',
      },
      {
        id: "FJ",
        value: 19429303,
        tooltip: '<span style="font-weight:bold;">Fiji</span><br />Population : 19429303',
      },
      {
        id: "FI",
        value: 4982595,
        tooltip: '<span style="font-weight:bold;">Finland</span><br />Population : 4982595',
      },
      {
        id: "FR",
        value: 54143079,
        tooltip: '<span style="font-weight:bold;">France</span><br />Population : 54143079',
      },
      {
        id: "GA",
        value: 16956015,
        tooltip: '<span style="font-weight:bold;">Gabon</span><br />Population : 16956015',
      },
      {
        id: "GM",
        value: 5880145,
        tooltip: '<span style="font-weight:bold;">Gambia</span><br />Population : 5880145',
      },
      {
        id: "GE",
        value: 44343155,
        tooltip: '<span style="font-weight:bold;">Georgia</span><br />Population : 44343155',
      },
      {
        id: "GH",
        value: 35387769,
        tooltip: '<span style="font-weight:bold;">Ghana</span><br />Population : 35387769',
      },
      {
        id: "GR",
        value: 57895969,
        tooltip: '<span style="font-weight:bold;">Greece</span><br />Population : 57895969',
      },
      {
        id: "GD",
        value: 9528839,
        tooltip: '<span style="font-weight:bold;">Grenada</span><br />Population : 9528839',
      },
      {
        id: "GT",
        value: 41469534,
        tooltip: '<span style="font-weight:bold;">Guatemala</span><br />Population : 41469534',
      },
      {
        id: "GN",
        value: 25406872,
        tooltip: '<span style="font-weight:bold;">Guinea</span><br />Population : 25406872',
      },
      {
        id: "GQ",
        value: 36947055,
        tooltip: '<span style="font-weight:bold;">Equatorial Guinea</span><br />Population : 36947055',
      },
      {
        id: "GW",
        value: 35991010,
        tooltip: '<span style="font-weight:bold;">Guinea-bissau</span><br />Population : 35991010',
      },
      {
        id: "GY",
        value: 9464859,
        tooltip: '<span style="font-weight:bold;">Guyana</span><br />Population : 9464859',
      },
      {
        id: "HT",
        value: 14841015,
        tooltip: '<span style="font-weight:bold;">Haiti</span><br />Population : 14841015',
      },
      {
        id: "HN",
        value: 12137399,
        tooltip: '<span style="font-weight:bold;">Honduras</span><br />Population : 12137399',
      },
      {
        id: "HU",
        value: 1032281,
        tooltip: '<span style="font-weight:bold;">Hungary</span><br />Population : 1032281',
      },
      {
        id: "JM",
        value: 51282254,
        tooltip: '<span style="font-weight:bold;">Jamaica</span><br />Population : 51282254',
      },
      {
        id: "JP",
        value: 24280823,
        tooltip: '<span style="font-weight:bold;">Japan</span><br />Population : 24280823',
      },
      {
        id: "MH",
        value: 11545126,
        tooltip: '<span style="font-weight:bold;">Marshall Islands</span><br />Population : 11545126',
      },
      {
        id: "PW",
        value: 30068280,
        tooltip: '<span style="font-weight:bold;">Palau</span><br />Population : 30068280',
      },
      {
        id: "SB",
        value: 324844,
        tooltip: '<span style="font-weight:bold;">Solomon Islands</span><br />Population : 324844',
      },
      {
        id: "IN",
        value: 44366919,
        tooltip: '<span style="font-weight:bold;">India</span><br />Population : 44366919',
      },
      {
        id: "ID",
        value: 33298361,
        tooltip: '<span style="font-weight:bold;">Indonesia</span><br />Population : 33298361',
      },
      {
        id: "JO",
        value: 38864630,
        tooltip: '<span style="font-weight:bold;">Jordan</span><br />Population : 38864630',
      },
      {
        id: "IR",
        value: 19445755,
        tooltip: '<span style="font-weight:bold;">Iran, Islamic Republic Of</span><br />Population : 19445755',
      },
      {
        id: "IQ",
        value: 35789929,
        tooltip: '<span style="font-weight:bold;">Iraq</span><br />Population : 35789929',
      },
      {
        id: "IE",
        value: 45575229,
        tooltip: '<span style="font-weight:bold;">Ireland</span><br />Population : 45575229',
      },
      {
        id: "IS",
        value: 33036957,
        tooltip: '<span style="font-weight:bold;">Iceland</span><br />Population : 33036957',
      },
      {
        id: "IL",
        value: 1948110,
        tooltip: '<span style="font-weight:bold;">Israel</span><br />Population : 1948110',
      },
      {
        id: "IT",
        value: 49090479,
        tooltip: '<span style="font-weight:bold;">Italy</span><br />Population : 49090479',
      },
      {
        id: "KZ",
        value: 46503855,
        tooltip: '<span style="font-weight:bold;">Kazakhstan</span><br />Population : 46503855',
      },
      {
        id: "KE",
        value: 48150885,
        tooltip: '<span style="font-weight:bold;">Kenya</span><br />Population : 48150885',
      },
      {
        id: "KG",
        value: 50785038,
        tooltip: '<span style="font-weight:bold;">Kyrgyzstan</span><br />Population : 50785038',
      },
      {
        id: "KI",
        value: 44959192,
        tooltip: '<span style="font-weight:bold;">Kiribati</span><br />Population : 44959192',
      },
      {
        id: "KW",
        value: 4262362,
        tooltip: '<span style="font-weight:bold;">Kuwait</span><br />Population : 4262362',
      },
      {
        id: "LA",
        value: 29922040,
        tooltip: "<span style=\"font-weight:bold;\">Lao People's Democratic Republic</span><br />Population : 29922040",
      },
      {
        id: "LS",
        value: 59259659,
        tooltip: '<span style="font-weight:bold;">Lesotho</span><br />Population : 59259659',
      },
      {
        id: "LV",
        value: 14036694,
        tooltip: '<span style="font-weight:bold;">Latvia</span><br />Population : 14036694',
      },
      {
        id: "LB",
        value: 36778879,
        tooltip: '<span style="font-weight:bold;">Lebanon</span><br />Population : 36778879',
      },
      {
        id: "LR",
        value: 13916046,
        tooltip: '<span style="font-weight:bold;">Liberia</span><br />Population : 13916046',
      },
      {
        id: "LY",
        value: 10525100,
        tooltip: '<span style="font-weight:bold;">Libya</span><br />Population : 10525100',
      },
      {
        id: "LI",
        value: 36813611,
        tooltip: '<span style="font-weight:bold;">Liechtenstein</span><br />Population : 36813611',
      },
      {
        id: "LT",
        value: 52331528,
        tooltip: '<span style="font-weight:bold;">Lithuania</span><br />Population : 52331528',
      },
      {
        id: "LU",
        value: 5748529,
        tooltip: '<span style="font-weight:bold;">Luxembourg</span><br />Population : 5748529',
      },
      {
        id: "MK",
        value: 37484488,
        tooltip: '<span style="font-weight:bold;">Macedonia, The Former Yugoslav Republic Of</span><br />Population : 37484488',
      },
      {
        id: "MG",
        value: 44030567,
        tooltip: '<span style="font-weight:bold;">Madagascar</span><br />Population : 44030567',
      },
      {
        id: "MY",
        value: 49048435,
        tooltip: '<span style="font-weight:bold;">Malaysia</span><br />Population : 49048435',
      },
      {
        id: "MW",
        value: 40985114,
        tooltip: '<span style="font-weight:bold;">Malawi</span><br />Population : 40985114',
      },
      {
        id: "MV",
        value: 3490945,
        tooltip: '<span style="font-weight:bold;">Maldives</span><br />Population : 3490945',
      },
      {
        id: "ML",
        value: 56278186,
        tooltip: '<span style="font-weight:bold;">Mali</span><br />Population : 56278186',
      },
      {
        id: "MT",
        value: 55007724,
        tooltip: '<span style="font-weight:bold;">Malta</span><br />Population : 55007724',
      },
      {
        id: "MA",
        value: 5441424,
        tooltip: '<span style="font-weight:bold;">Morocco</span><br />Population : 5441424',
      },
      {
        id: "MU",
        value: 41447598,
        tooltip: '<span style="font-weight:bold;">Mauritius</span><br />Population : 41447598',
      },
      {
        id: "MR",
        value: 4297094,
        tooltip: '<span style="font-weight:bold;">Mauritania</span><br />Population : 4297094',
      },
      {
        id: "MX",
        value: 8437521,
        tooltip: '<span style="font-weight:bold;">Mexico</span><br />Population : 8437521',
      },
      {
        id: "FM",
        value: 54483088,
        tooltip: '<span style="font-weight:bold;">Micronesia, Federated States Of</span><br />Population : 54483088',
      },
      {
        id: "MD",
        value: 14707571,
        tooltip: '<span style="font-weight:bold;">Moldova, Republic Of</span><br />Population : 14707571',
      },
      {
        id: "MC",
        value: 28477917,
        tooltip: '<span style="font-weight:bold;">Monaco</span><br />Population : 28477917',
      },
      {
        id: "MN",
        value: 57215952,
        tooltip: '<span style="font-weight:bold;">Mongolia</span><br />Population : 57215952',
      },
      {
        id: "ME",
        value: 14025726,
        tooltip: '<span style="font-weight:bold;">Montenegro</span><br />Population : 14025726',
      },
      {
        id: "MZ",
        value: 56173990,
        tooltip: '<span style="font-weight:bold;">Mozambique</span><br />Population : 56173990',
      },
      {
        id: "NA",
        value: 59561280,
        tooltip: '<span style="font-weight:bold;">Namibia</span><br />Population : 59561280',
      },
      {
        id: "NP",
        value: 19771139,
        tooltip: '<span style="font-weight:bold;">Nepal</span><br />Population : 19771139',
      },
      {
        id: "NI",
        value: 39434967,
        tooltip: '<span style="font-weight:bold;">Nicaragua</span><br />Population : 39434967',
      },
      {
        id: "NE",
        value: 29199979,
        tooltip: '<span style="font-weight:bold;">Niger</span><br />Population : 29199979',
      },
      {
        id: "NG",
        value: 58237806,
        tooltip: '<span style="font-weight:bold;">Nigeria</span><br />Population : 58237806',
      },
      {
        id: "NO",
        value: 43981211,
        tooltip: '<span style="font-weight:bold;">Norway</span><br />Population : 43981211',
      },
      {
        id: "NZ",
        value: 16526434,
        tooltip: '<span style="font-weight:bold;">New Zealand</span><br />Population : 16526434',
      },
      {
        id: "OM",
        value: 6788662,
        tooltip: '<span style="font-weight:bold;">Oman</span><br />Population : 6788662',
      },
      {
        id: "UG",
        value: 15148120,
        tooltip: '<span style="font-weight:bold;">Uganda</span><br />Population : 15148120',
      },
      {
        id: "UZ",
        value: 8174289,
        tooltip: '<span style="font-weight:bold;">Uzbekistan</span><br />Population : 8174289',
      },
      {
        id: "PK",
        value: 40765753,
        tooltip: '<span style="font-weight:bold;">Pakistan</span><br />Population : 40765753',
      },
      {
        id: "PS",
        value: 31993167,
        tooltip: '<span style="font-weight:bold;">Palestine, State Of</span><br />Population : 31993167',
      },
      {
        id: "PA",
        value: 10782849,
        tooltip: '<span style="font-weight:bold;">Panama</span><br />Population : 10782849',
      },
      {
        id: "PG",
        value: 328500,
        tooltip: '<span style="font-weight:bold;">Papua New Guinea</span><br />Population : 328500',
      },
      {
        id: "PY",
        value: 57868549,
        tooltip: '<span style="font-weight:bold;">Paraguay</span><br />Population : 57868549',
      },
      {
        id: "NL",
        value: 58016617,
        tooltip: '<span style="font-weight:bold;">Netherlands</span><br />Population : 58016617',
      },
      {
        id: "PE",
        value: 35782617,
        tooltip: '<span style="font-weight:bold;">Peru</span><br />Population : 35782617',
      },
      {
        id: "PH",
        value: 18571969,
        tooltip: '<span style="font-weight:bold;">Philippines</span><br />Population : 18571969',
      },
      {
        id: "PL",
        value: 43500446,
        tooltip: '<span style="font-weight:bold;">Poland</span><br />Population : 43500446',
      },
      {
        id: "PT",
        value: 8112136,
        tooltip: '<span style="font-weight:bold;">Portugal</span><br />Population : 8112136',
      },
      {
        id: "QA",
        value: 50838050,
        tooltip: '<span style="font-weight:bold;">Qatar</span><br />Population : 50838050',
      },
      {
        id: "DO",
        value: 31082822,
        tooltip: '<span style="font-weight:bold;">Dominican Republic</span><br />Population : 31082822',
      },
      {
        id: "RO",
        value: 3277069,
        tooltip: '<span style="font-weight:bold;">Romania</span><br />Population : 3277069',
      },
      {
        id: "GB",
        value: 15182852,
        tooltip: '<span style="font-weight:bold;">United Kingdom</span><br />Population : 15182852',
      },
      {
        id: "RU",
        value: 46589771,
        tooltip: '<span style="font-weight:bold;">Russian Federation</span><br />Population : 46589771',
      },
      {
        id: "RW",
        value: 35989182,
        tooltip: '<span style="font-weight:bold;">Rwanda</span><br />Population : 35989182',
      },
      {
        id: "KN",
        value: 32664044,
        tooltip: '<span style="font-weight:bold;">Saint Kitts And Nevis</span><br />Population : 32664044',
      },
      {
        id: "SM",
        value: 2481887,
        tooltip: '<span style="font-weight:bold;">San Marino</span><br />Population : 2481887',
      },
      {
        id: "VC",
        value: 43628406,
        tooltip: '<span style="font-weight:bold;">Saint Vincent And The Grenadines</span><br />Population : 43628406',
      },
      {
        id: "LC",
        value: 1469174,
        tooltip: '<span style="font-weight:bold;">Saint Lucia</span><br />Population : 1469174',
      },
      {
        id: "SV",
        value: 17476996,
        tooltip: '<span style="font-weight:bold;">El Salvador</span><br />Population : 17476996',
      },
      {
        id: "WS",
        value: 43012369,
        tooltip: '<span style="font-weight:bold;">Samoa</span><br />Population : 43012369',
      },
      {
        id: "ST",
        value: 32594580,
        tooltip: '<span style="font-weight:bold;">Sao Tome And Principe</span><br />Population : 32594580',
      },
      {
        id: "SN",
        value: 45450925,
        tooltip: '<span style="font-weight:bold;">Senegal</span><br />Population : 45450925',
      },
      {
        id: "RS",
        value: 53181549,
        tooltip: '<span style="font-weight:bold;">Serbia</span><br />Population : 53181549',
      },
      {
        id: "SC",
        value: 127420,
        tooltip: '<span style="font-weight:bold;">Seychelles</span><br />Population : 127420',
      },
      {
        id: "SL",
        value: 34078919,
        tooltip: '<span style="font-weight:bold;">Sierra Leone</span><br />Population : 34078919',
      },
      {
        id: "SG",
        value: 16312558,
        tooltip: '<span style="font-weight:bold;">Singapore</span><br />Population : 16312558',
      },
      {
        id: "SK",
        value: 25593329,
        tooltip: '<span style="font-weight:bold;">Slovakia</span><br />Population : 25593329',
      },
      {
        id: "SI",
        value: 6730166,
        tooltip: '<span style="font-weight:bold;">Slovenia</span><br />Population : 6730166',
      },
      {
        id: "SO",
        value: 38722046,
        tooltip: '<span style="font-weight:bold;">Somalia</span><br />Population : 38722046',
      },
      {
        id: "SD",
        value: 31982199,
        tooltip: '<span style="font-weight:bold;">Sudan</span><br />Population : 31982199',
      },
      {
        id: "SS",
        value: 30177960,
        tooltip: '<span style="font-weight:bold;">South Sudan</span><br />Population : 30177960',
      },
      {
        id: "LK",
        value: 45973734,
        tooltip: '<span style="font-weight:bold;">Sri Lanka</span><br />Population : 45973734',
      },
      {
        id: "SE",
        value: 7214587,
        tooltip: '<span style="font-weight:bold;">Sweden</span><br />Population : 7214587',
      },
      {
        id: "CH",
        value: 737973,
        tooltip: '<span style="font-weight:bold;">Switzerland</span><br />Population : 737973',
      },
      {
        id: "SR",
        value: 12651068,
        tooltip: '<span style="font-weight:bold;">Suriname</span><br />Population : 12651068',
      },
      {
        id: "SZ",
        value: 11161245,
        tooltip: '<span style="font-weight:bold;">Swaziland</span><br />Population : 11161245',
      },
      {
        id: "SY",
        value: 49997168,
        tooltip: '<span style="font-weight:bold;">Syrian Arab Republic</span><br />Population : 49997168',
      },
      {
        id: "TJ",
        value: 40508005,
        tooltip: '<span style="font-weight:bold;">Tajikistan</span><br />Population : 40508005',
      },
      {
        id: "TZ",
        value: 8578277,
        tooltip: '<span style="font-weight:bold;">Tanzania, United Republic Of</span><br />Population : 8578277',
      },
      {
        id: "TD",
        value: 5245828,
        tooltip: '<span style="font-weight:bold;">Chad</span><br />Population : 5245828',
      },
      {
        id: "CZ",
        value: 7960412,
        tooltip: '<span style="font-weight:bold;">Czech Republic</span><br />Population : 7960412',
      },
      {
        id: "TH",
        value: 59570420,
        tooltip: '<span style="font-weight:bold;">Thailand</span><br />Population : 59570420',
      },
      {
        id: "TL",
        value: 23575214,
        tooltip: '<span style="font-weight:bold;">Timor-leste</span><br />Population : 23575214',
      },
      {
        id: "TG",
        value: 41330606,
        tooltip: '<span style="font-weight:bold;">Togo</span><br />Population : 41330606',
      },
      {
        id: "TO",
        value: 51444947,
        tooltip: '<span style="font-weight:bold;">Tonga</span><br />Population : 51444947',
      },
      {
        id: "TT",
        value: 56053342,
        tooltip: '<span style="font-weight:bold;">Trinidad And Tobago</span><br />Population : 56053342',
      },
      {
        id: "TN",
        value: 33307501,
        tooltip: '<span style="font-weight:bold;">Tunisia</span><br />Population : 33307501',
      },
      {
        id: "TM",
        value: 42668704,
        tooltip: '<span style="font-weight:bold;">Turkmenistan</span><br />Population : 42668704',
      },
      {
        id: "TR",
        value: 21341394,
        tooltip: '<span style="font-weight:bold;">Turkey</span><br />Population : 21341394',
      },
      {
        id: "TV",
        value: 58034897,
        tooltip: '<span style="font-weight:bold;">Tuvalu</span><br />Population : 58034897',
      },
      {
        id: "VU",
        value: 43390766,
        tooltip: '<span style="font-weight:bold;">Vanuatu</span><br />Population : 43390766',
      },
      {
        id: "VE",
        value: 22363248,
        tooltip: '<span style="font-weight:bold;">Venezuela, Bolivarian Republic Of</span><br />Population : 22363248',
      },
      {
        id: "VN",
        value: 28090381,
        tooltip: '<span style="font-weight:bold;">Viet Nam</span><br />Population : 28090381',
      },
      {
        id: "UA",
        value: 3743209,
        tooltip: '<span style="font-weight:bold;">Ukraine</span><br />Population : 3743209',
      },
      {
        id: "UY",
        value: 29490631,
        tooltip: '<span style="font-weight:bold;">Uruguay</span><br />Population : 29490631',
      },
      {
        id: "YE",
        value: 23467361,
        tooltip: '<span style="font-weight:bold;">Yemen</span><br />Population : 23467361',
      },
      {
        id: "ZM",
        value: 32382532,
        tooltip: '<span style="font-weight:bold;">Zambia</span><br />Population : 32382532',
      },
      {
        id: "ZW",
        value: 41056406,
        tooltip: '<span style="font-weight:bold;">Zimbabwe</span><br />Population : 41056406',
      },
    ],
  },
  2015: {
    areas: [
      {
        id: "AF",
        value: 52466800,
        tooltip: '<span style="font-weight:bold;">Afghanistan</span><br />Population : 52466800',
      },
      {
        id: "ZA",
        value: 26108826,
        tooltip: '<span style="font-weight:bold;">South Africa</span><br />Population : 26108826',
      },
      {
        id: "AL",
        value: 53559946,
        tooltip: '<span style="font-weight:bold;">Albania</span><br />Population : 53559946',
      },
      {
        id: "DZ",
        value: 49796088,
        tooltip: '<span style="font-weight:bold;">Algeria</span><br />Population : 49796088',
      },
      {
        id: "DE",
        value: 16718374,
        tooltip: '<span style="font-weight:bold;">Germany</span><br />Population : 16718374',
      },
      {
        id: "AD",
        value: 26774219,
        tooltip: '<span style="font-weight:bold;">Andorra</span><br />Population : 26774219',
      },
      {
        id: "AO",
        value: 54956540,
        tooltip: '<span style="font-weight:bold;">Angola</span><br />Population : 54956540',
      },
      {
        id: "AG",
        value: 56018610,
        tooltip: '<span style="font-weight:bold;">Antigua And Barbuda</span><br />Population : 56018610',
      },
      {
        id: "SA",
        value: 54792020,
        tooltip: '<span style="font-weight:bold;">Saudi Arabia</span><br />Population : 54792020',
      },
      {
        id: "AR",
        value: 47445276,
        tooltip: '<span style="font-weight:bold;">Argentina</span><br />Population : 47445276',
      },
      {
        id: "AM",
        value: 20670517,
        tooltip: '<span style="font-weight:bold;">Armenia</span><br />Population : 20670517',
      },
      {
        id: "AU",
        value: 6435858,
        tooltip: '<span style="font-weight:bold;">Australia</span><br />Population : 6435858',
      },
      {
        id: "AT",
        value: 59990860,
        tooltip: '<span style="font-weight:bold;">Austria</span><br />Population : 59990860',
      },
      {
        id: "AZ",
        value: 18862622,
        tooltip: '<span style="font-weight:bold;">Azerbaijan</span><br />Population : 18862622',
      },
      {
        id: "BS",
        value: 8730001,
        tooltip: '<span style="font-weight:bold;">Bahamas</span><br />Population : 8730001',
      },
      {
        id: "BH",
        value: 56413459,
        tooltip: '<span style="font-weight:bold;">Bahrain</span><br />Population : 56413459',
      },
      {
        id: "BD",
        value: 15468020,
        tooltip: '<span style="font-weight:bold;">Bangladesh</span><br />Population : 15468020',
      },
      {
        id: "BB",
        value: 21516882,
        tooltip: '<span style="font-weight:bold;">Barbados</span><br />Population : 21516882',
      },
      {
        id: "BE",
        value: 47213120,
        tooltip: '<span style="font-weight:bold;">Belgium</span><br />Population : 47213120',
      },
      {
        id: "BZ",
        value: 31867035,
        tooltip: '<span style="font-weight:bold;">Belize</span><br />Population : 31867035',
      },
      {
        id: "BJ",
        value: 54126627,
        tooltip: '<span style="font-weight:bold;">Benin</span><br />Population : 54126627',
      },
      {
        id: "BT",
        value: 46048682,
        tooltip: '<span style="font-weight:bold;">Bhutan</span><br />Population : 46048682',
      },
      {
        id: "BY",
        value: 14447995,
        tooltip: '<span style="font-weight:bold;">Belarus</span><br />Population : 14447995',
      },
      {
        id: "MM",
        value: 28262213,
        tooltip: '<span style="font-weight:bold;">Myanmar</span><br />Population : 28262213',
      },
      {
        id: "BO",
        value: 39319803,
        tooltip: '<span style="font-weight:bold;">Bolivia, Plurinational State Of</span><br />Population : 39319803',
      },
      {
        id: "BA",
        value: 53148645,
        tooltip: '<span style="font-weight:bold;">Bosnia And Herzegovina</span><br />Population : 53148645',
      },
      {
        id: "BW",
        value: 58312754,
        tooltip: '<span style="font-weight:bold;">Botswana</span><br />Population : 58312754',
      },
      {
        id: "BR",
        value: 51214618,
        tooltip: '<span style="font-weight:bold;">Brazil</span><br />Population : 51214618',
      },
      {
        id: "BN",
        value: 44050675,
        tooltip: '<span style="font-weight:bold;">Brunei Darussalam</span><br />Population : 44050675',
      },
      {
        id: "BG",
        value: 33457398,
        tooltip: '<span style="font-weight:bold;">Bulgaria</span><br />Population : 33457398',
      },
      {
        id: "BF",
        value: 57135520,
        tooltip: '<span style="font-weight:bold;">Burkina Faso</span><br />Population : 57135520',
      },
      {
        id: "BI",
        value: 16489874,
        tooltip: '<span style="font-weight:bold;">Burundi</span><br />Population : 16489874',
      },
      {
        id: "KH",
        value: 51472367,
        tooltip: '<span style="font-weight:bold;">Cambodia</span><br />Population : 51472367',
      },
      {
        id: "CM",
        value: 7565564,
        tooltip: '<span style="font-weight:bold;">Cameroon</span><br />Population : 7565564',
      },
      {
        id: "CA",
        value: 38994418,
        tooltip: '<span style="font-weight:bold;">Canada</span><br />Population : 38994418',
      },
      {
        id: "CV",
        value: 49503608,
        tooltip: '<span style="font-weight:bold;">Cape Verde</span><br />Population : 49503608',
      },
      {
        id: "CF",
        value: 14788003,
        tooltip: '<span style="font-weight:bold;">Central African Republic</span><br />Population : 14788003',
      },
      {
        id: "CL",
        value: 26013769,
        tooltip: '<span style="font-weight:bold;">Chile</span><br />Population : 26013769',
      },
      {
        id: "CN",
        value: 2017575,
        tooltip: '<span style="font-weight:bold;">China</span><br />Population : 2017575',
      },
      {
        id: "CY",
        value: 6121441,
        tooltip: '<span style="font-weight:bold;">Cyprus</span><br />Population : 6121441',
      },
      {
        id: "CO",
        value: 36950711,
        tooltip: '<span style="font-weight:bold;">Colombia</span><br />Population : 36950711',
      },
      {
        id: "KM",
        value: 49492639,
        tooltip: '<span style="font-weight:bold;">Comoros</span><br />Population : 49492639',
      },
      {
        id: "CG",
        value: 34183115,
        tooltip: '<span style="font-weight:bold;">Congo</span><br />Population : 34183115',
      },
      {
        id: "CD",
        value: 11759002,
        tooltip: '<span style="font-weight:bold;">Congo, The Democratic Republic Of The</span><br />Population : 11759002',
      },
      {
        id: "KP",
        value: 11263614,
        tooltip: "<span style=\"font-weight:bold;\">Korea, Democratic People's Republic Of</span><br />Population : 11263614",
      },
      {
        id: "KR",
        value: 8742797,
        tooltip: '<span style="font-weight:bold;">Korea, Republic Of</span><br />Population : 8742797',
      },
      {
        id: "CR",
        value: 13819162,
        tooltip: '<span style="font-weight:bold;">Costa Rica</span><br />Population : 13819162',
      },
      {
        id: "CI",
        value: 42081915,
        tooltip: "<span style=\"font-weight:bold;\">C\u00d4te D'ivoire</span><br />Population : 42081915",
      },
      {
        id: "HR",
        value: 40679837,
        tooltip: '<span style="font-weight:bold;">Croatia</span><br />Population : 40679837',
      },
      {
        id: "CU",
        value: 44154871,
        tooltip: '<span style="font-weight:bold;">Cuba</span><br />Population : 44154871',
      },
      {
        id: "DK",
        value: 28903842,
        tooltip: '<span style="font-weight:bold;">Denmark</span><br />Population : 28903842',
      },
      {
        id: "DJ",
        value: 42805805,
        tooltip: '<span style="font-weight:bold;">Djibouti</span><br />Population : 42805805',
      },
      {
        id: "DM",
        value: 18502505,
        tooltip: '<span style="font-weight:bold;">Dominica</span><br />Population : 18502505',
      },
      {
        id: "EG",
        value: 26569482,
        tooltip: '<span style="font-weight:bold;">Egypt</span><br />Population : 26569482',
      },
      {
        id: "AE",
        value: 17665280,
        tooltip: '<span style="font-weight:bold;">United Arab Emirates</span><br />Population : 17665280',
      },
      {
        id: "EC",
        value: 49496295,
        tooltip: '<span style="font-weight:bold;">Ecuador</span><br />Population : 49496295',
      },
      {
        id: "ER",
        value: 47684745,
        tooltip: '<span style="font-weight:bold;">Eritrea</span><br />Population : 47684745',
      },
      {
        id: "ES",
        value: 36477258,
        tooltip: '<span style="font-weight:bold;">Spain</span><br />Population : 36477258',
      },
      {
        id: "EE",
        value: 8181601,
        tooltip: '<span style="font-weight:bold;">Estonia</span><br />Population : 8181601',
      },
      {
        id: "US",
        value: 7869012,
        tooltip: '<span style="font-weight:bold;">United States</span><br />Population : 7869012',
      },
      {
        id: "ET",
        value: 21529678,
        tooltip: '<span style="font-weight:bold;">Ethiopia</span><br />Population : 21529678',
      },
      {
        id: "FJ",
        value: 4618823,
        tooltip: '<span style="font-weight:bold;">Fiji</span><br />Population : 4618823',
      },
      {
        id: "FI",
        value: 58480930,
        tooltip: '<span style="font-weight:bold;">Finland</span><br />Population : 58480930',
      },
      {
        id: "FR",
        value: 13389581,
        tooltip: '<span style="font-weight:bold;">France</span><br />Population : 13389581',
      },
      {
        id: "GA",
        value: 42990433,
        tooltip: '<span style="font-weight:bold;">Gabon</span><br />Population : 42990433',
      },
      {
        id: "GM",
        value: 11484802,
        tooltip: '<span style="font-weight:bold;">Gambia</span><br />Population : 11484802',
      },
      {
        id: "GE",
        value: 16941391,
        tooltip: '<span style="font-weight:bold;">Georgia</span><br />Population : 16941391',
      },
      {
        id: "GH",
        value: 11773626,
        tooltip: '<span style="font-weight:bold;">Ghana</span><br />Population : 11773626',
      },
      {
        id: "GR",
        value: 5370132,
        tooltip: '<span style="font-weight:bold;">Greece</span><br />Population : 5370132',
      },
      {
        id: "GD",
        value: 47715821,
        tooltip: '<span style="font-weight:bold;">Grenada</span><br />Population : 47715821',
      },
      {
        id: "GT",
        value: 1491110,
        tooltip: '<span style="font-weight:bold;">Guatemala</span><br />Population : 1491110',
      },
      {
        id: "GN",
        value: 38586774,
        tooltip: '<span style="font-weight:bold;">Guinea</span><br />Population : 38586774',
      },
      {
        id: "GQ",
        value: 11621902,
        tooltip: '<span style="font-weight:bold;">Equatorial Guinea</span><br />Population : 11621902',
      },
      {
        id: "GW",
        value: 14102502,
        tooltip: '<span style="font-weight:bold;">Guinea-bissau</span><br />Population : 14102502',
      },
      {
        id: "GY",
        value: 40208212,
        tooltip: '<span style="font-weight:bold;">Guyana</span><br />Population : 40208212',
      },
      {
        id: "HT",
        value: 39544647,
        tooltip: '<span style="font-weight:bold;">Haiti</span><br />Population : 39544647',
      },
      {
        id: "HN",
        value: 14948868,
        tooltip: '<span style="font-weight:bold;">Honduras</span><br />Population : 14948868',
      },
      {
        id: "HU",
        value: 21085473,
        tooltip: '<span style="font-weight:bold;">Hungary</span><br />Population : 21085473',
      },
      {
        id: "JM",
        value: 11420822,
        tooltip: '<span style="font-weight:bold;">Jamaica</span><br />Population : 11420822',
      },
      {
        id: "JP",
        value: 50212873,
        tooltip: '<span style="font-weight:bold;">Japan</span><br />Population : 50212873',
      },
      {
        id: "MH",
        value: 58404154,
        tooltip: '<span style="font-weight:bold;">Marshall Islands</span><br />Population : 58404154',
      },
      {
        id: "PW",
        value: 29355359,
        tooltip: '<span style="font-weight:bold;">Palau</span><br />Population : 29355359',
      },
      {
        id: "SB",
        value: 3107064,
        tooltip: '<span style="font-weight:bold;">Solomon Islands</span><br />Population : 3107064',
      },
      {
        id: "IN",
        value: 16307074,
        tooltip: '<span style="font-weight:bold;">India</span><br />Population : 16307074',
      },
      {
        id: "ID",
        value: 35290884,
        tooltip: '<span style="font-weight:bold;">Indonesia</span><br />Population : 35290884',
      },
      {
        id: "JO",
        value: 29552783,
        tooltip: '<span style="font-weight:bold;">Jordan</span><br />Population : 29552783',
      },
      {
        id: "IR",
        value: 13395065,
        tooltip: '<span style="font-weight:bold;">Iran, Islamic Republic Of</span><br />Population : 13395065',
      },
      {
        id: "IQ",
        value: 33292877,
        tooltip: '<span style="font-weight:bold;">Iraq</span><br />Population : 33292877',
      },
      {
        id: "IE",
        value: 48562186,
        tooltip: '<span style="font-weight:bold;">Ireland</span><br />Population : 48562186',
      },
      {
        id: "IS",
        value: 42268372,
        tooltip: '<span style="font-weight:bold;">Iceland</span><br />Population : 42268372',
      },
      {
        id: "IL",
        value: 10462948,
        tooltip: '<span style="font-weight:bold;">Israel</span><br />Population : 10462948',
      },
      {
        id: "IT",
        value: 46885907,
        tooltip: '<span style="font-weight:bold;">Italy</span><br />Population : 46885907',
      },
      {
        id: "KZ",
        value: 51421183,
        tooltip: '<span style="font-weight:bold;">Kazakhstan</span><br />Population : 51421183',
      },
      {
        id: "KE",
        value: 58142749,
        tooltip: '<span style="font-weight:bold;">Kenya</span><br />Population : 58142749',
      },
      {
        id: "KG",
        value: 52338840,
        tooltip: '<span style="font-weight:bold;">Kyrgyzstan</span><br />Population : 52338840',
      },
      {
        id: "KI",
        value: 32751788,
        tooltip: '<span style="font-weight:bold;">Kiribati</span><br />Population : 32751788',
      },
      {
        id: "KW",
        value: 27020999,
        tooltip: '<span style="font-weight:bold;">Kuwait</span><br />Population : 27020999',
      },
      {
        id: "LA",
        value: 37866541,
        tooltip: "<span style=\"font-weight:bold;\">Lao People's Democratic Republic</span><br />Population : 37866541",
      },
      {
        id: "LS",
        value: 47300864,
        tooltip: '<span style="font-weight:bold;">Lesotho</span><br />Population : 47300864',
      },
      {
        id: "LV",
        value: 56406147,
        tooltip: '<span style="font-weight:bold;">Latvia</span><br />Population : 56406147',
      },
      {
        id: "LB",
        value: 48364762,
        tooltip: '<span style="font-weight:bold;">Lebanon</span><br />Population : 48364762',
      },
      {
        id: "LR",
        value: 31980371,
        tooltip: '<span style="font-weight:bold;">Liberia</span><br />Population : 31980371',
      },
      {
        id: "LY",
        value: 53377146,
        tooltip: '<span style="font-weight:bold;">Libya</span><br />Population : 53377146',
      },
      {
        id: "LI",
        value: 33614606,
        tooltip: '<span style="font-weight:bold;">Liechtenstein</span><br />Population : 33614606',
      },
      {
        id: "LT",
        value: 38705594,
        tooltip: '<span style="font-weight:bold;">Lithuania</span><br />Population : 38705594',
      },
      {
        id: "LU",
        value: 1174865,
        tooltip: '<span style="font-weight:bold;">Luxembourg</span><br />Population : 1174865',
      },
      {
        id: "MK",
        value: 38745810,
        tooltip: '<span style="font-weight:bold;">Macedonia, The Former Yugoslav Republic Of</span><br />Population : 38745810',
      },
      {
        id: "MG",
        value: 29892792,
        tooltip: '<span style="font-weight:bold;">Madagascar</span><br />Population : 29892792',
      },
      {
        id: "MY",
        value: 11146621,
        tooltip: '<span style="font-weight:bold;">Malaysia</span><br />Population : 11146621',
      },
      {
        id: "MW",
        value: 55890650,
        tooltip: '<span style="font-weight:bold;">Malawi</span><br />Population : 55890650',
      },
      {
        id: "MV",
        value: 1534982,
        tooltip: '<span style="font-weight:bold;">Maldives</span><br />Population : 1534982',
      },
      {
        id: "ML",
        value: 20906329,
        tooltip: '<span style="font-weight:bold;">Mali</span><br />Population : 20906329',
      },
      {
        id: "MT",
        value: 8740969,
        tooltip: '<span style="font-weight:bold;">Malta</span><br />Population : 8740969',
      },
      {
        id: "MA",
        value: 37018347,
        tooltip: '<span style="font-weight:bold;">Morocco</span><br />Population : 37018347',
      },
      {
        id: "MU",
        value: 29722787,
        tooltip: '<span style="font-weight:bold;">Mauritius</span><br />Population : 29722787',
      },
      {
        id: "MR",
        value: 12270843,
        tooltip: '<span style="font-weight:bold;">Mauritania</span><br />Population : 12270843',
      },
      {
        id: "MX",
        value: 44591764,
        tooltip: '<span style="font-weight:bold;">Mexico</span><br />Population : 44591764',
      },
      {
        id: "FM",
        value: 54998584,
        tooltip: '<span style="font-weight:bold;">Micronesia, Federated States Of</span><br />Population : 54998584',
      },
      {
        id: "MD",
        value: 1637350,
        tooltip: '<span style="font-weight:bold;">Moldova, Republic Of</span><br />Population : 1637350',
      },
      {
        id: "MC",
        value: 39551959,
        tooltip: '<span style="font-weight:bold;">Monaco</span><br />Population : 39551959',
      },
      {
        id: "MN",
        value: 41952127,
        tooltip: '<span style="font-weight:bold;">Mongolia</span><br />Population : 41952127',
      },
      {
        id: "ME",
        value: 10621985,
        tooltip: '<span style="font-weight:bold;">Montenegro</span><br />Population : 10621985',
      },
      {
        id: "MZ",
        value: 5256796,
        tooltip: '<span style="font-weight:bold;">Mozambique</span><br />Population : 5256796',
      },
      {
        id: "NA",
        value: 48465302,
        tooltip: '<span style="font-weight:bold;">Namibia</span><br />Population : 48465302',
      },
      {
        id: "NP",
        value: 13925186,
        tooltip: '<span style="font-weight:bold;">Nepal</span><br />Population : 13925186',
      },
      {
        id: "NI",
        value: 14329175,
        tooltip: '<span style="font-weight:bold;">Nicaragua</span><br />Population : 14329175',
      },
      {
        id: "NE",
        value: 38709250,
        tooltip: '<span style="font-weight:bold;">Niger</span><br />Population : 38709250',
      },
      {
        id: "NG",
        value: 14676495,
        tooltip: '<span style="font-weight:bold;">Nigeria</span><br />Population : 14676495',
      },
      {
        id: "NO",
        value: 3564065,
        tooltip: '<span style="font-weight:bold;">Norway</span><br />Population : 3564065',
      },
      {
        id: "NZ",
        value: 26810779,
        tooltip: '<span style="font-weight:bold;">New Zealand</span><br />Population : 26810779',
      },
      {
        id: "OM",
        value: 10272836,
        tooltip: '<span style="font-weight:bold;">Oman</span><br />Population : 10272836',
      },
      {
        id: "UG",
        value: 3701165,
        tooltip: '<span style="font-weight:bold;">Uganda</span><br />Population : 3701165',
      },
      {
        id: "UZ",
        value: 23971890,
        tooltip: '<span style="font-weight:bold;">Uzbekistan</span><br />Population : 23971890',
      },
      {
        id: "PK",
        value: 38707422,
        tooltip: '<span style="font-weight:bold;">Pakistan</span><br />Population : 38707422',
      },
      {
        id: "PS",
        value: 37875681,
        tooltip: '<span style="font-weight:bold;">Palestine, State Of</span><br />Population : 37875681',
      },
      {
        id: "PA",
        value: 51104938,
        tooltip: '<span style="font-weight:bold;">Panama</span><br />Population : 51104938',
      },
      {
        id: "PG",
        value: 58301786,
        tooltip: '<span style="font-weight:bold;">Papua New Guinea</span><br />Population : 58301786',
      },
      {
        id: "PY",
        value: 10709729,
        tooltip: '<span style="font-weight:bold;">Paraguay</span><br />Population : 10709729',
      },
      {
        id: "NL",
        value: 29795908,
        tooltip: '<span style="font-weight:bold;">Netherlands</span><br />Population : 29795908',
      },
      {
        id: "PE",
        value: 42703436,
        tooltip: '<span style="font-weight:bold;">Peru</span><br />Population : 42703436',
      },
      {
        id: "PH",
        value: 59756876,
        tooltip: '<span style="font-weight:bold;">Philippines</span><br />Population : 59756876',
      },
      {
        id: "PL",
        value: 53258326,
        tooltip: '<span style="font-weight:bold;">Poland</span><br />Population : 53258326',
      },
      {
        id: "PT",
        value: 44061643,
        tooltip: '<span style="font-weight:bold;">Portugal</span><br />Population : 44061643',
      },
      {
        id: "QA",
        value: 14062286,
        tooltip: '<span style="font-weight:bold;">Qatar</span><br />Population : 14062286',
      },
      {
        id: "DO",
        value: 11490286,
        tooltip: '<span style="font-weight:bold;">Dominican Republic</span><br />Population : 11490286',
      },
      {
        id: "RO",
        value: 7243835,
        tooltip: '<span style="font-weight:bold;">Romania</span><br />Population : 7243835',
      },
      {
        id: "GB",
        value: 48851010,
        tooltip: '<span style="font-weight:bold;">United Kingdom</span><br />Population : 48851010',
      },
      {
        id: "RU",
        value: 30697113,
        tooltip: '<span style="font-weight:bold;">Russian Federation</span><br />Population : 30697113',
      },
      {
        id: "RW",
        value: 46405142,
        tooltip: '<span style="font-weight:bold;">Rwanda</span><br />Population : 46405142',
      },
      {
        id: "KN",
        value: 43006885,
        tooltip: '<span style="font-weight:bold;">Saint Kitts And Nevis</span><br />Population : 43006885',
      },
      {
        id: "SM",
        value: 42292136,
        tooltip: '<span style="font-weight:bold;">San Marino</span><br />Population : 42292136',
      },
      {
        id: "VC",
        value: 8373541,
        tooltip: '<span style="font-weight:bold;">Saint Vincent And The Grenadines</span><br />Population : 8373541',
      },
      {
        id: "LC",
        value: 27854568,
        tooltip: '<span style="font-weight:bold;">Saint Lucia</span><br />Population : 27854568',
      },
      {
        id: "SV",
        value: 1438098,
        tooltip: '<span style="font-weight:bold;">El Salvador</span><br />Population : 1438098',
      },
      {
        id: "WS",
        value: 52463144,
        tooltip: '<span style="font-weight:bold;">Samoa</span><br />Population : 52463144',
      },
      {
        id: "ST",
        value: 12607196,
        tooltip: '<span style="font-weight:bold;">Sao Tome And Principe</span><br />Population : 12607196',
      },
      {
        id: "SN",
        value: 28841690,
        tooltip: '<span style="font-weight:bold;">Senegal</span><br />Population : 28841690',
      },
      {
        id: "RS",
        value: 52878101,
        tooltip: '<span style="font-weight:bold;">Serbia</span><br />Population : 52878101',
      },
      {
        id: "SC",
        value: 17592160,
        tooltip: '<span style="font-weight:bold;">Seychelles</span><br />Population : 17592160',
      },
      {
        id: "SL",
        value: 19063702,
        tooltip: '<span style="font-weight:bold;">Sierra Leone</span><br />Population : 19063702',
      },
      {
        id: "SG",
        value: 32519632,
        tooltip: '<span style="font-weight:bold;">Singapore</span><br />Population : 32519632',
      },
      {
        id: "SK",
        value: 38217517,
        tooltip: '<span style="font-weight:bold;">Slovakia</span><br />Population : 38217517',
      },
      {
        id: "SI",
        value: 25657309,
        tooltip: '<span style="font-weight:bold;">Slovenia</span><br />Population : 25657309',
      },
      {
        id: "SO",
        value: 33358685,
        tooltip: '<span style="font-weight:bold;">Somalia</span><br />Population : 33358685',
      },
      {
        id: "SD",
        value: 51991520,
        tooltip: '<span style="font-weight:bold;">Sudan</span><br />Population : 51991520',
      },
      {
        id: "SS",
        value: 7996972,
        tooltip: '<span style="font-weight:bold;">South Sudan</span><br />Population : 7996972',
      },
      {
        id: "LK",
        value: 14886715,
        tooltip: '<span style="font-weight:bold;">Sri Lanka</span><br />Population : 14886715',
      },
      {
        id: "SE",
        value: 31157770,
        tooltip: '<span style="font-weight:bold;">Sweden</span><br />Population : 31157770',
      },
      {
        id: "CH",
        value: 10510476,
        tooltip: '<span style="font-weight:bold;">Switzerland</span><br />Population : 10510476',
      },
      {
        id: "SR",
        value: 42707092,
        tooltip: '<span style="font-weight:bold;">Suriname</span><br />Population : 42707092',
      },
      {
        id: "SZ",
        value: 13358505,
        tooltip: '<span style="font-weight:bold;">Swaziland</span><br />Population : 13358505',
      },
      {
        id: "SY",
        value: 18076581,
        tooltip: '<span style="font-weight:bold;">Syrian Arab Republic</span><br />Population : 18076581',
      },
      {
        id: "TJ",
        value: 40979630,
        tooltip: '<span style="font-weight:bold;">Tajikistan</span><br />Population : 40979630',
      },
      {
        id: "TZ",
        value: 13188501,
        tooltip: '<span style="font-weight:bold;">Tanzania, United Republic Of</span><br />Population : 13188501',
      },
      {
        id: "TD",
        value: 19200802,
        tooltip: '<span style="font-weight:bold;">Chad</span><br />Population : 19200802',
      },
      {
        id: "CZ",
        value: 29680743,
        tooltip: '<span style="font-weight:bold;">Czech Republic</span><br />Population : 29680743',
      },
      {
        id: "TH",
        value: 6752102,
        tooltip: '<span style="font-weight:bold;">Thailand</span><br />Population : 6752102',
      },
      {
        id: "TL",
        value: 59831824,
        tooltip: '<span style="font-weight:bold;">Timor-leste</span><br />Population : 59831824',
      },
      {
        id: "TG",
        value: 591732,
        tooltip: '<span style="font-weight:bold;">Togo</span><br />Population : 591732',
      },
      {
        id: "TO",
        value: 11685882,
        tooltip: '<span style="font-weight:bold;">Tonga</span><br />Population : 11685882',
      },
      {
        id: "TT",
        value: 40731021,
        tooltip: '<span style="font-weight:bold;">Trinidad And Tobago</span><br />Population : 40731021',
      },
      {
        id: "TN",
        value: 53477686,
        tooltip: '<span style="font-weight:bold;">Tunisia</span><br />Population : 53477686',
      },
      {
        id: "TM",
        value: 15559421,
        tooltip: '<span style="font-weight:bold;">Turkmenistan</span><br />Population : 15559421',
      },
      {
        id: "TR",
        value: 59557624,
        tooltip: '<span style="font-weight:bold;">Turkey</span><br />Population : 59557624',
      },
      {
        id: "TV",
        value: 6269509,
        tooltip: '<span style="font-weight:bold;">Tuvalu</span><br />Population : 6269509',
      },
      {
        id: "VU",
        value: 14716711,
        tooltip: '<span style="font-weight:bold;">Vanuatu</span><br />Population : 14716711',
      },
      {
        id: "VE",
        value: 32281992,
        tooltip: '<span style="font-weight:bold;">Venezuela, Bolivarian Republic Of</span><br />Population : 32281992',
      },
      {
        id: "VN",
        value: 59111591,
        tooltip: '<span style="font-weight:bold;">Viet Nam</span><br />Population : 59111591',
      },
      {
        id: "UA",
        value: 36270694,
        tooltip: '<span style="font-weight:bold;">Ukraine</span><br />Population : 36270694',
      },
      {
        id: "UY",
        value: 53989527,
        tooltip: '<span style="font-weight:bold;">Uruguay</span><br />Population : 53989527',
      },
      {
        id: "YE",
        value: 48887571,
        tooltip: '<span style="font-weight:bold;">Yemen</span><br />Population : 48887571',
      },
      {
        id: "ZM",
        value: 45913410,
        tooltip: '<span style="font-weight:bold;">Zambia</span><br />Population : 45913410',
      },
      {
        id: "ZW",
        value: 53987699,
        tooltip: '<span style="font-weight:bold;">Zimbabwe</span><br />Population : 53987699',
      },
    ],
  },
  2016: {
    areas: [
      {
        id: "AF",
        value: 44310251,
        tooltip: '<span style="font-weight:bold;">Afghanistan</span><br />Population : 44310251',
      },
      {
        id: "ZA",
        value: 33673102,
        tooltip: '<span style="font-weight:bold;">South Africa</span><br />Population : 33673102',
      },
      {
        id: "AL",
        value: 15131668,
        tooltip: '<span style="font-weight:bold;">Albania</span><br />Population : 15131668',
      },
      {
        id: "DZ",
        value: 37266956,
        tooltip: '<span style="font-weight:bold;">Algeria</span><br />Population : 37266956',
      },
      {
        id: "DE",
        value: 49333603,
        tooltip: '<span style="font-weight:bold;">Germany</span><br />Population : 49333603',
      },
      {
        id: "AD",
        value: 15912225,
        tooltip: '<span style="font-weight:bold;">Andorra</span><br />Population : 15912225',
      },
      {
        id: "AO",
        value: 14714883,
        tooltip: '<span style="font-weight:bold;">Angola</span><br />Population : 14714883',
      },
      {
        id: "AG",
        value: 55481177,
        tooltip: '<span style="font-weight:bold;">Antigua And Barbuda</span><br />Population : 55481177',
      },
      {
        id: "SA",
        value: 46752463,
        tooltip: '<span style="font-weight:bold;">Saudi Arabia</span><br />Population : 46752463',
      },
      {
        id: "AR",
        value: 7861700,
        tooltip: '<span style="font-weight:bold;">Argentina</span><br />Population : 7861700',
      },
      {
        id: "AM",
        value: 54426419,
        tooltip: '<span style="font-weight:bold;">Armenia</span><br />Population : 54426419',
      },
      {
        id: "AU",
        value: 15082312,
        tooltip: '<span style="font-weight:bold;">Australia</span><br />Population : 15082312',
      },
      {
        id: "AT",
        value: 4744955,
        tooltip: '<span style="font-weight:bold;">Austria</span><br />Population : 4744955',
      },
      {
        id: "AZ",
        value: 15137152,
        tooltip: '<span style="font-weight:bold;">Azerbaijan</span><br />Population : 15137152',
      },
      {
        id: "BS",
        value: 27569400,
        tooltip: '<span style="font-weight:bold;">Bahamas</span><br />Population : 27569400',
      },
      {
        id: "BH",
        value: 26510986,
        tooltip: '<span style="font-weight:bold;">Bahrain</span><br />Population : 26510986',
      },
      {
        id: "BD",
        value: 41239206,
        tooltip: '<span style="font-weight:bold;">Bangladesh</span><br />Population : 41239206',
      },
      {
        id: "BB",
        value: 13404205,
        tooltip: '<span style="font-weight:bold;">Barbados</span><br />Population : 13404205',
      },
      {
        id: "BE",
        value: 37096951,
        tooltip: '<span style="font-weight:bold;">Belgium</span><br />Population : 37096951',
      },
      {
        id: "BZ",
        value: 50457825,
        tooltip: '<span style="font-weight:bold;">Belize</span><br />Population : 50457825',
      },
      {
        id: "BJ",
        value: 4613339,
        tooltip: '<span style="font-weight:bold;">Benin</span><br />Population : 4613339',
      },
      {
        id: "BT",
        value: 8278485,
        tooltip: '<span style="font-weight:bold;">Bhutan</span><br />Population : 8278485',
      },
      {
        id: "BY",
        value: 36212198,
        tooltip: '<span style="font-weight:bold;">Belarus</span><br />Population : 36212198',
      },
      {
        id: "MM",
        value: 17663452,
        tooltip: '<span style="font-weight:bold;">Myanmar</span><br />Population : 17663452',
      },
      {
        id: "BO",
        value: 12795480,
        tooltip: '<span style="font-weight:bold;">Bolivia, Plurinational State Of</span><br />Population : 12795480',
      },
      {
        id: "BA",
        value: 35325617,
        tooltip: '<span style="font-weight:bold;">Bosnia And Herzegovina</span><br />Population : 35325617',
      },
      {
        id: "BW",
        value: 8068264,
        tooltip: '<span style="font-weight:bold;">Botswana</span><br />Population : 8068264',
      },
      {
        id: "BR",
        value: 8618493,
        tooltip: '<span style="font-weight:bold;">Brazil</span><br />Population : 8618493',
      },
      {
        id: "BN",
        value: 33963754,
        tooltip: '<span style="font-weight:bold;">Brunei Darussalam</span><br />Population : 33963754',
      },
      {
        id: "BG",
        value: 40261225,
        tooltip: '<span style="font-weight:bold;">Bulgaria</span><br />Population : 40261225',
      },
      {
        id: "BF",
        value: 25668277,
        tooltip: '<span style="font-weight:bold;">Burkina Faso</span><br />Population : 25668277',
      },
      {
        id: "BI",
        value: 13963574,
        tooltip: '<span style="font-weight:bold;">Burundi</span><br />Population : 13963574',
      },
      {
        id: "KH",
        value: 6346286,
        tooltip: '<span style="font-weight:bold;">Cambodia</span><br />Population : 6346286',
      },
      {
        id: "CM",
        value: 58650934,
        tooltip: '<span style="font-weight:bold;">Cameroon</span><br />Population : 58650934',
      },
      {
        id: "CA",
        value: 12265359,
        tooltip: '<span style="font-weight:bold;">Canada</span><br />Population : 12265359',
      },
      {
        id: "CV",
        value: 54289319,
        tooltip: '<span style="font-weight:bold;">Cape Verde</span><br />Population : 54289319',
      },
      {
        id: "CF",
        value: 17921200,
        tooltip: '<span style="font-weight:bold;">Central African Republic</span><br />Population : 17921200',
      },
      {
        id: "CL",
        value: 36210370,
        tooltip: '<span style="font-weight:bold;">Chile</span><br />Population : 36210370',
      },
      {
        id: "CN",
        value: 40862638,
        tooltip: '<span style="font-weight:bold;">China</span><br />Population : 40862638',
      },
      {
        id: "CY",
        value: 436352,
        tooltip: '<span style="font-weight:bold;">Cyprus</span><br />Population : 436352',
      },
      {
        id: "CO",
        value: 6916623,
        tooltip: '<span style="font-weight:bold;">Colombia</span><br />Population : 6916623',
      },
      {
        id: "KM",
        value: 8505157,
        tooltip: '<span style="font-weight:bold;">Comoros</span><br />Population : 8505157',
      },
      {
        id: "CG",
        value: 34713236,
        tooltip: '<span style="font-weight:bold;">Congo</span><br />Population : 34713236',
      },
      {
        id: "CD",
        value: 52695301,
        tooltip: '<span style="font-weight:bold;">Congo, The Democratic Republic Of The</span><br />Population : 52695301',
      },
      {
        id: "KP",
        value: 1410678,
        tooltip: "<span style=\"font-weight:bold;\">Korea, Democratic People's Republic Of</span><br />Population : 1410678",
      },
      {
        id: "KR",
        value: 41050922,
        tooltip: '<span style="font-weight:bold;">Korea, Republic Of</span><br />Population : 41050922',
      },
      {
        id: "CR",
        value: 6920279,
        tooltip: '<span style="font-weight:bold;">Costa Rica</span><br />Population : 6920279',
      },
      {
        id: "CI",
        value: 22006787,
        tooltip: "<span style=\"font-weight:bold;\">C\u00d4te D'ivoire</span><br />Population : 22006787",
      },
      {
        id: "HR",
        value: 59431492,
        tooltip: '<span style="font-weight:bold;">Croatia</span><br />Population : 59431492',
      },
      {
        id: "CU",
        value: 49613288,
        tooltip: '<span style="font-weight:bold;">Cuba</span><br />Population : 49613288',
      },
      {
        id: "DK",
        value: 536892,
        tooltip: '<span style="font-weight:bold;">Denmark</span><br />Population : 536892',
      },
      {
        id: "DJ",
        value: 48761438,
        tooltip: '<span style="font-weight:bold;">Djibouti</span><br />Population : 48761438',
      },
      {
        id: "DM",
        value: 29357187,
        tooltip: '<span style="font-weight:bold;">Dominica</span><br />Population : 29357187',
      },
      {
        id: "EG",
        value: 39807880,
        tooltip: '<span style="font-weight:bold;">Egypt</span><br />Population : 39807880',
      },
      {
        id: "AE",
        value: 28666202,
        tooltip: '<span style="font-weight:bold;">United Arab Emirates</span><br />Population : 28666202',
      },
      {
        id: "EC",
        value: 3799877,
        tooltip: '<span style="font-weight:bold;">Ecuador</span><br />Population : 3799877',
      },
      {
        id: "ER",
        value: 29115890,
        tooltip: '<span style="font-weight:bold;">Eritrea</span><br />Population : 29115890',
      },
      {
        id: "ES",
        value: 47200324,
        tooltip: '<span style="font-weight:bold;">Spain</span><br />Population : 47200324',
      },
      {
        id: "EE",
        value: 14561331,
        tooltip: '<span style="font-weight:bold;">Estonia</span><br />Population : 14561331',
      },
      {
        id: "US",
        value: 27512732,
        tooltip: '<span style="font-weight:bold;">United States</span><br />Population : 27512732',
      },
      {
        id: "ET",
        value: 26885727,
        tooltip: '<span style="font-weight:bold;">Ethiopia</span><br />Population : 26885727',
      },
      {
        id: "FJ",
        value: 17506244,
        tooltip: '<span style="font-weight:bold;">Fiji</span><br />Population : 17506244',
      },
      {
        id: "FI",
        value: 31225406,
        tooltip: '<span style="font-weight:bold;">Finland</span><br />Population : 31225406',
      },
      {
        id: "FR",
        value: 50640625,
        tooltip: '<span style="font-weight:bold;">France</span><br />Population : 50640625',
      },
      {
        id: "GA",
        value: 20794821,
        tooltip: '<span style="font-weight:bold;">Gabon</span><br />Population : 20794821',
      },
      {
        id: "GM",
        value: 46191266,
        tooltip: '<span style="font-weight:bold;">Gambia</span><br />Population : 46191266',
      },
      {
        id: "GE",
        value: 1911550,
        tooltip: '<span style="font-weight:bold;">Georgia</span><br />Population : 1911550',
      },
      {
        id: "GH",
        value: 33874182,
        tooltip: '<span style="font-weight:bold;">Ghana</span><br />Population : 33874182',
      },
      {
        id: "GR",
        value: 38921298,
        tooltip: '<span style="font-weight:bold;">Greece</span><br />Population : 38921298',
      },
      {
        id: "GD",
        value: 19071014,
        tooltip: '<span style="font-weight:bold;">Grenada</span><br />Population : 19071014',
      },
      {
        id: "GT",
        value: 59522892,
        tooltip: '<span style="font-weight:bold;">Guatemala</span><br />Population : 59522892',
      },
      {
        id: "GN",
        value: 27754028,
        tooltip: '<span style="font-weight:bold;">Guinea</span><br />Population : 27754028',
      },
      {
        id: "GQ",
        value: 19493283,
        tooltip: '<span style="font-weight:bold;">Equatorial Guinea</span><br />Population : 19493283',
      },
      {
        id: "GW",
        value: 31611115,
        tooltip: '<span style="font-weight:bold;">Guinea-bissau</span><br />Population : 31611115',
      },
      {
        id: "GY",
        value: 7512552,
        tooltip: '<span style="font-weight:bold;">Guyana</span><br />Population : 7512552',
      },
      {
        id: "HT",
        value: 52870789,
        tooltip: '<span style="font-weight:bold;">Haiti</span><br />Population : 52870789',
      },
      {
        id: "HN",
        value: 50488901,
        tooltip: '<span style="font-weight:bold;">Honduras</span><br />Population : 50488901',
      },
      {
        id: "HU",
        value: 29527191,
        tooltip: '<span style="font-weight:bold;">Hungary</span><br />Population : 29527191',
      },
      {
        id: "JM",
        value: 38683658,
        tooltip: '<span style="font-weight:bold;">Jamaica</span><br />Population : 38683658',
      },
      {
        id: "JP",
        value: 39965088,
        tooltip: '<span style="font-weight:bold;">Japan</span><br />Population : 39965088',
      },
      {
        id: "MH",
        value: 10236276,
        tooltip: '<span style="font-weight:bold;">Marshall Islands</span><br />Population : 10236276',
      },
      {
        id: "PW",
        value: 48384870,
        tooltip: '<span style="font-weight:bold;">Palau</span><br />Population : 48384870',
      },
      {
        id: "SB",
        value: 16389334,
        tooltip: '<span style="font-weight:bold;">Solomon Islands</span><br />Population : 16389334',
      },
      {
        id: "IN",
        value: 9627551,
        tooltip: '<span style="font-weight:bold;">India</span><br />Population : 9627551',
      },
      {
        id: "ID",
        value: 46613535,
        tooltip: '<span style="font-weight:bold;">Indonesia</span><br />Population : 46613535',
      },
      {
        id: "JO",
        value: 33899774,
        tooltip: '<span style="font-weight:bold;">Jordan</span><br />Population : 33899774',
      },
      {
        id: "IR",
        value: 13632705,
        tooltip: '<span style="font-weight:bold;">Iran, Islamic Republic Of</span><br />Population : 13632705',
      },
      {
        id: "IQ",
        value: 12398803,
        tooltip: '<span style="font-weight:bold;">Iraq</span><br />Population : 12398803',
      },
      {
        id: "IE",
        value: 37948801,
        tooltip: '<span style="font-weight:bold;">Ireland</span><br />Population : 37948801',
      },
      {
        id: "IS",
        value: 21637530,
        tooltip: '<span style="font-weight:bold;">Iceland</span><br />Population : 21637530',
      },
      {
        id: "IL",
        value: 13566897,
        tooltip: '<span style="font-weight:bold;">Israel</span><br />Population : 13566897',
      },
      {
        id: "IT",
        value: 8969470,
        tooltip: '<span style="font-weight:bold;">Italy</span><br />Population : 8969470',
      },
      {
        id: "KZ",
        value: 12320199,
        tooltip: '<span style="font-weight:bold;">Kazakhstan</span><br />Population : 12320199',
      },
      {
        id: "KE",
        value: 17213763,
        tooltip: '<span style="font-weight:bold;">Kenya</span><br />Population : 17213763',
      },
      {
        id: "KG",
        value: 29295035,
        tooltip: '<span style="font-weight:bold;">Kyrgyzstan</span><br />Population : 29295035',
      },
      {
        id: "KI",
        value: 49880176,
        tooltip: '<span style="font-weight:bold;">Kiribati</span><br />Population : 49880176',
      },
      {
        id: "KW",
        value: 27755856,
        tooltip: '<span style="font-weight:bold;">Kuwait</span><br />Population : 27755856',
      },
      {
        id: "LA",
        value: 56194098,
        tooltip: "<span style=\"font-weight:bold;\">Lao People's Democratic Republic</span><br />Population : 56194098",
      },
      {
        id: "LS",
        value: 43970243,
        tooltip: '<span style="font-weight:bold;">Lesotho</span><br />Population : 43970243',
      },
      {
        id: "LV",
        value: 35921546,
        tooltip: '<span style="font-weight:bold;">Latvia</span><br />Population : 35921546',
      },
      {
        id: "LB",
        value: 52433896,
        tooltip: '<span style="font-weight:bold;">Lebanon</span><br />Population : 52433896',
      },
      {
        id: "LR",
        value: 24394159,
        tooltip: '<span style="font-weight:bold;">Liberia</span><br />Population : 24394159',
      },
      {
        id: "LY",
        value: 10795645,
        tooltip: '<span style="font-weight:bold;">Libya</span><br />Population : 10795645',
      },
      {
        id: "LI",
        value: 17634204,
        tooltip: '<span style="font-weight:bold;">Liechtenstein</span><br />Population : 17634204',
      },
      {
        id: "LT",
        value: 24582443,
        tooltip: '<span style="font-weight:bold;">Lithuania</span><br />Population : 24582443',
      },
      {
        id: "LU",
        value: 17279571,
        tooltip: '<span style="font-weight:bold;">Luxembourg</span><br />Population : 17279571',
      },
      {
        id: "MK",
        value: 32724368,
        tooltip: '<span style="font-weight:bold;">Macedonia, The Former Yugoslav Republic Of</span><br />Population : 32724368',
      },
      {
        id: "MG",
        value: 15608777,
        tooltip: '<span style="font-weight:bold;">Madagascar</span><br />Population : 15608777',
      },
      {
        id: "MY",
        value: 32179623,
        tooltip: '<span style="font-weight:bold;">Malaysia</span><br />Population : 32179623',
      },
      {
        id: "MW",
        value: 40465961,
        tooltip: '<span style="font-weight:bold;">Malawi</span><br />Population : 40465961',
      },
      {
        id: "MV",
        value: 3059536,
        tooltip: '<span style="font-weight:bold;">Maldives</span><br />Population : 3059536',
      },
      {
        id: "ML",
        value: 20485889,
        tooltip: '<span style="font-weight:bold;">Mali</span><br />Population : 20485889',
      },
      {
        id: "MT",
        value: 13453561,
        tooltip: '<span style="font-weight:bold;">Malta</span><br />Population : 13453561',
      },
      {
        id: "MA",
        value: 9718951,
        tooltip: '<span style="font-weight:bold;">Morocco</span><br />Population : 9718951',
      },
      {
        id: "MU",
        value: 24754275,
        tooltip: '<span style="font-weight:bold;">Mauritius</span><br />Population : 24754275',
      },
      {
        id: "MR",
        value: 52856165,
        tooltip: '<span style="font-weight:bold;">Mauritania</span><br />Population : 52856165',
      },
      {
        id: "MX",
        value: 56382383,
        tooltip: '<span style="font-weight:bold;">Mexico</span><br />Population : 56382383',
      },
      {
        id: "FM",
        value: 50454169,
        tooltip: '<span style="font-weight:bold;">Micronesia, Federated States Of</span><br />Population : 50454169',
      },
      {
        id: "MD",
        value: 51011710,
        tooltip: '<span style="font-weight:bold;">Moldova, Republic Of</span><br />Population : 51011710',
      },
      {
        id: "MC",
        value: 43460230,
        tooltip: '<span style="font-weight:bold;">Monaco</span><br />Population : 43460230',
      },
      {
        id: "MN",
        value: 39294211,
        tooltip: '<span style="font-weight:bold;">Mongolia</span><br />Population : 39294211',
      },
      {
        id: "ME",
        value: 18537237,
        tooltip: '<span style="font-weight:bold;">Montenegro</span><br />Population : 18537237',
      },
      {
        id: "MZ",
        value: 5084964,
        tooltip: '<span style="font-weight:bold;">Mozambique</span><br />Population : 5084964',
      },
      {
        id: "NA",
        value: 12888708,
        tooltip: '<span style="font-weight:bold;">Namibia</span><br />Population : 12888708',
      },
      {
        id: "NP",
        value: 50167173,
        tooltip: '<span style="font-weight:bold;">Nepal</span><br />Population : 50167173',
      },
      {
        id: "NI",
        value: 39383783,
        tooltip: '<span style="font-weight:bold;">Nicaragua</span><br />Population : 39383783',
      },
      {
        id: "NE",
        value: 19877164,
        tooltip: '<span style="font-weight:bold;">Niger</span><br />Population : 19877164',
      },
      {
        id: "NG",
        value: 11682226,
        tooltip: '<span style="font-weight:bold;">Nigeria</span><br />Population : 11682226',
      },
      {
        id: "NO",
        value: 27229391,
        tooltip: '<span style="font-weight:bold;">Norway</span><br />Population : 27229391',
      },
      {
        id: "NZ",
        value: 28759430,
        tooltip: '<span style="font-weight:bold;">New Zealand</span><br />Population : 28759430',
      },
      {
        id: "OM",
        value: 18641434,
        tooltip: '<span style="font-weight:bold;">Oman</span><br />Population : 18641434',
      },
      {
        id: "UG",
        value: 531408,
        tooltip: '<span style="font-weight:bold;">Uganda</span><br />Population : 531408',
      },
      {
        id: "UZ",
        value: 58458994,
        tooltip: '<span style="font-weight:bold;">Uzbekistan</span><br />Population : 58458994',
      },
      {
        id: "PK",
        value: 52179804,
        tooltip: '<span style="font-weight:bold;">Pakistan</span><br />Population : 52179804',
      },
      {
        id: "PS",
        value: 14480899,
        tooltip: '<span style="font-weight:bold;">Palestine, State Of</span><br />Population : 14480899',
      },
      {
        id: "PA",
        value: 29976880,
        tooltip: '<span style="font-weight:bold;">Panama</span><br />Population : 29976880',
      },
      {
        id: "PG",
        value: 22184103,
        tooltip: '<span style="font-weight:bold;">Papua New Guinea</span><br />Population : 22184103',
      },
      {
        id: "PY",
        value: 25410528,
        tooltip: '<span style="font-weight:bold;">Paraguay</span><br />Population : 25410528',
      },
      {
        id: "NL",
        value: 50448685,
        tooltip: '<span style="font-weight:bold;">Netherlands</span><br />Population : 50448685',
      },
      {
        id: "PE",
        value: 809265,
        tooltip: '<span style="font-weight:bold;">Peru</span><br />Population : 809265',
      },
      {
        id: "PH",
        value: 6382846,
        tooltip: '<span style="font-weight:bold;">Philippines</span><br />Population : 6382846',
      },
      {
        id: "PL",
        value: 13967230,
        tooltip: '<span style="font-weight:bold;">Poland</span><br />Population : 13967230',
      },
      {
        id: "PT",
        value: 19847915,
        tooltip: '<span style="font-weight:bold;">Portugal</span><br />Population : 19847915',
      },
      {
        id: "QA",
        value: 23469189,
        tooltip: '<span style="font-weight:bold;">Qatar</span><br />Population : 23469189',
      },
      {
        id: "DO",
        value: 9183346,
        tooltip: '<span style="font-weight:bold;">Dominican Republic</span><br />Population : 9183346',
      },
      {
        id: "RO",
        value: 53415534,
        tooltip: '<span style="font-weight:bold;">Romania</span><br />Population : 53415534',
      },
      {
        id: "GB",
        value: 25631717,
        tooltip: '<span style="font-weight:bold;">United Kingdom</span><br />Population : 25631717',
      },
      {
        id: "RU",
        value: 58647278,
        tooltip: '<span style="font-weight:bold;">Russian Federation</span><br />Population : 58647278',
      },
      {
        id: "RW",
        value: 58663730,
        tooltip: '<span style="font-weight:bold;">Rwanda</span><br />Population : 58663730',
      },
      {
        id: "KN",
        value: 29571063,
        tooltip: '<span style="font-weight:bold;">Saint Kitts And Nevis</span><br />Population : 29571063',
      },
      {
        id: "SM",
        value: 21003213,
        tooltip: '<span style="font-weight:bold;">San Marino</span><br />Population : 21003213',
      },
      {
        id: "VC",
        value: 37084155,
        tooltip: '<span style="font-weight:bold;">Saint Vincent And The Grenadines</span><br />Population : 37084155',
      },
      {
        id: "LC",
        value: 33152121,
        tooltip: '<span style="font-weight:bold;">Saint Lucia</span><br />Population : 33152121',
      },
      {
        id: "SV",
        value: 37899445,
        tooltip: '<span style="font-weight:bold;">El Salvador</span><br />Population : 37899445',
      },
      {
        id: "WS",
        value: 49015531,
        tooltip: '<span style="font-weight:bold;">Samoa</span><br />Population : 49015531',
      },
      {
        id: "ST",
        value: 39270447,
        tooltip: '<span style="font-weight:bold;">Sao Tome And Principe</span><br />Population : 39270447',
      },
      {
        id: "SN",
        value: 20626645,
        tooltip: '<span style="font-weight:bold;">Senegal</span><br />Population : 20626645',
      },
      {
        id: "RS",
        value: 24116302,
        tooltip: '<span style="font-weight:bold;">Serbia</span><br />Population : 24116302',
      },
      {
        id: "SC",
        value: 2971792,
        tooltip: '<span style="font-weight:bold;">Seychelles</span><br />Population : 2971792',
      },
      {
        id: "SL",
        value: 55846778,
        tooltip: '<span style="font-weight:bold;">Sierra Leone</span><br />Population : 55846778',
      },
      {
        id: "SG",
        value: 19215426,
        tooltip: '<span style="font-weight:bold;">Singapore</span><br />Population : 19215426',
      },
      {
        id: "SK",
        value: 23787262,
        tooltip: '<span style="font-weight:bold;">Slovakia</span><br />Population : 23787262',
      },
      {
        id: "SI",
        value: 45725125,
        tooltip: '<span style="font-weight:bold;">Slovenia</span><br />Population : 45725125',
      },
      {
        id: "SO",
        value: 47503772,
        tooltip: '<span style="font-weight:bold;">Somalia</span><br />Population : 47503772',
      },
      {
        id: "SD",
        value: 56996592,
        tooltip: '<span style="font-weight:bold;">Sudan</span><br />Population : 56996592',
      },
      {
        id: "SS",
        value: 42527948,
        tooltip: '<span style="font-weight:bold;">South Sudan</span><br />Population : 42527948',
      },
      {
        id: "LK",
        value: 10678653,
        tooltip: '<span style="font-weight:bold;">Sri Lanka</span><br />Population : 10678653',
      },
      {
        id: "SE",
        value: 4882055,
        tooltip: '<span style="font-weight:bold;">Sweden</span><br />Population : 4882055',
      },
      {
        id: "CH",
        value: 12298263,
        tooltip: '<span style="font-weight:bold;">Switzerland</span><br />Population : 12298263',
      },
      {
        id: "SR",
        value: 56003986,
        tooltip: '<span style="font-weight:bold;">Suriname</span><br />Population : 56003986',
      },
      {
        id: "SZ",
        value: 785501,
        tooltip: '<span style="font-weight:bold;">Swaziland</span><br />Population : 785501',
      },
      {
        id: "SY",
        value: 8472253,
        tooltip: '<span style="font-weight:bold;">Syrian Arab Republic</span><br />Population : 8472253',
      },
      {
        id: "TJ",
        value: 32998569,
        tooltip: '<span style="font-weight:bold;">Tajikistan</span><br />Population : 32998569',
      },
      {
        id: "TZ",
        value: 9930999,
        tooltip: '<span style="font-weight:bold;">Tanzania, United Republic Of</span><br />Population : 9930999',
      },
      {
        id: "TD",
        value: 29148795,
        tooltip: '<span style="font-weight:bold;">Chad</span><br />Population : 29148795',
      },
      {
        id: "CZ",
        value: 48914991,
        tooltip: '<span style="font-weight:bold;">Czech Republic</span><br />Population : 48914991',
      },
      {
        id: "TH",
        value: 57325632,
        tooltip: '<span style="font-weight:bold;">Thailand</span><br />Population : 57325632',
      },
      {
        id: "TL",
        value: 59674616,
        tooltip: '<span style="font-weight:bold;">Timor-leste</span><br />Population : 59674616',
      },
      {
        id: "TG",
        value: 19021658,
        tooltip: '<span style="font-weight:bold;">Togo</span><br />Population : 19021658',
      },
      {
        id: "TO",
        value: 27000891,
        tooltip: '<span style="font-weight:bold;">Tonga</span><br />Population : 27000891',
      },
      {
        id: "TT",
        value: 53457578,
        tooltip: '<span style="font-weight:bold;">Trinidad And Tobago</span><br />Population : 53457578',
      },
      {
        id: "TN",
        value: 31150458,
        tooltip: '<span style="font-weight:bold;">Tunisia</span><br />Population : 31150458',
      },
      {
        id: "TM",
        value: 43407218,
        tooltip: '<span style="font-weight:bold;">Turkmenistan</span><br />Population : 43407218',
      },
      {
        id: "TR",
        value: 53170581,
        tooltip: '<span style="font-weight:bold;">Turkey</span><br />Population : 53170581',
      },
      {
        id: "TV",
        value: 19522531,
        tooltip: '<span style="font-weight:bold;">Tuvalu</span><br />Population : 19522531',
      },
      {
        id: "VU",
        value: 19824151,
        tooltip: '<span style="font-weight:bold;">Vanuatu</span><br />Population : 19824151',
      },
      {
        id: "VE",
        value: 25558597,
        tooltip: '<span style="font-weight:bold;">Venezuela, Bolivarian Republic Of</span><br />Population : 25558597',
      },
      {
        id: "VN",
        value: 28214685,
        tooltip: '<span style="font-weight:bold;">Viet Nam</span><br />Population : 28214685',
      },
      {
        id: "UA",
        value: 43498618,
        tooltip: '<span style="font-weight:bold;">Ukraine</span><br />Population : 43498618',
      },
      {
        id: "UY",
        value: 31311322,
        tooltip: '<span style="font-weight:bold;">Uruguay</span><br />Population : 31311322',
      },
      {
        id: "YE",
        value: 38478922,
        tooltip: '<span style="font-weight:bold;">Yemen</span><br />Population : 38478922',
      },
      {
        id: "ZM",
        value: 2673828,
        tooltip: '<span style="font-weight:bold;">Zambia</span><br />Population : 2673828',
      },
      {
        id: "ZW",
        value: 3713961,
        tooltip: '<span style="font-weight:bold;">Zimbabwe</span><br />Population : 3713961',
      },
    ],
  },
  2017: {
    areas: [
      {
        id: "AF",
        value: 59288907,
        tooltip: '<span style="font-weight:bold;">Afghanistan</span><br />Population : 59288907',
      },
      {
        id: "ZA",
        value: 2249731,
        tooltip: '<span style="font-weight:bold;">South Africa</span><br />Population : 2249731',
      },
      {
        id: "AL",
        value: 54824924,
        tooltip: '<span style="font-weight:bold;">Albania</span><br />Population : 54824924',
      },
      {
        id: "DZ",
        value: 49159943,
        tooltip: '<span style="font-weight:bold;">Algeria</span><br />Population : 49159943',
      },
      {
        id: "DE",
        value: 3534817,
        tooltip: '<span style="font-weight:bold;">Germany</span><br />Population : 3534817',
      },
      {
        id: "AD",
        value: 38597742,
        tooltip: '<span style="font-weight:bold;">Andorra</span><br />Population : 38597742',
      },
      {
        id: "AO",
        value: 52126792,
        tooltip: '<span style="font-weight:bold;">Angola</span><br />Population : 52126792',
      },
      {
        id: "AG",
        value: 28357269,
        tooltip: '<span style="font-weight:bold;">Antigua And Barbuda</span><br />Population : 28357269',
      },
      {
        id: "SA",
        value: 30962173,
        tooltip: '<span style="font-weight:bold;">Saudi Arabia</span><br />Population : 30962173',
      },
      {
        id: "AR",
        value: 36923291,
        tooltip: '<span style="font-weight:bold;">Argentina</span><br />Population : 36923291',
      },
      {
        id: "AM",
        value: 38080417,
        tooltip: '<span style="font-weight:bold;">Armenia</span><br />Population : 38080417',
      },
      {
        id: "AU",
        value: 28496197,
        tooltip: '<span style="font-weight:bold;">Australia</span><br />Population : 28496197',
      },
      {
        id: "AT",
        value: 4924099,
        tooltip: '<span style="font-weight:bold;">Austria</span><br />Population : 4924099',
      },
      {
        id: "AZ",
        value: 17817004,
        tooltip: '<span style="font-weight:bold;">Azerbaijan</span><br />Population : 17817004',
      },
      {
        id: "BS",
        value: 40763925,
        tooltip: '<span style="font-weight:bold;">Bahamas</span><br />Population : 40763925',
      },
      {
        id: "BH",
        value: 55192353,
        tooltip: '<span style="font-weight:bold;">Bahrain</span><br />Population : 55192353',
      },
      {
        id: "BD",
        value: 58323722,
        tooltip: '<span style="font-weight:bold;">Bangladesh</span><br />Population : 58323722',
      },
      {
        id: "BB",
        value: 31819507,
        tooltip: '<span style="font-weight:bold;">Barbados</span><br />Population : 31819507',
      },
      {
        id: "BE",
        value: 58305442,
        tooltip: '<span style="font-weight:bold;">Belgium</span><br />Population : 58305442',
      },
      {
        id: "BZ",
        value: 24211359,
        tooltip: '<span style="font-weight:bold;">Belize</span><br />Population : 24211359',
      },
      {
        id: "BJ",
        value: 54514164,
        tooltip: '<span style="font-weight:bold;">Benin</span><br />Population : 54514164',
      },
      {
        id: "BT",
        value: 39621423,
        tooltip: '<span style="font-weight:bold;">Bhutan</span><br />Population : 39621423',
      },
      {
        id: "BY",
        value: 58883091,
        tooltip: '<span style="font-weight:bold;">Belarus</span><br />Population : 58883091',
      },
      {
        id: "MM",
        value: 1068841,
        tooltip: '<span style="font-weight:bold;">Myanmar</span><br />Population : 1068841',
      },
      {
        id: "BO",
        value: 6598550,
        tooltip: '<span style="font-weight:bold;">Bolivia, Plurinational State Of</span><br />Population : 6598550',
      },
      {
        id: "BA",
        value: 31863379,
        tooltip: '<span style="font-weight:bold;">Bosnia And Herzegovina</span><br />Population : 31863379',
      },
      {
        id: "BW",
        value: 40624997,
        tooltip: '<span style="font-weight:bold;">Botswana</span><br />Population : 40624997',
      },
      {
        id: "BR",
        value: 21330426,
        tooltip: '<span style="font-weight:bold;">Brazil</span><br />Population : 21330426',
      },
      {
        id: "BN",
        value: 17530008,
        tooltip: '<span style="font-weight:bold;">Brunei Darussalam</span><br />Population : 17530008',
      },
      {
        id: "BG",
        value: 29135999,
        tooltip: '<span style="font-weight:bold;">Bulgaria</span><br />Population : 29135999',
      },
      {
        id: "BF",
        value: 31609287,
        tooltip: '<span style="font-weight:bold;">Burkina Faso</span><br />Population : 31609287',
      },
      {
        id: "BI",
        value: 30711737,
        tooltip: '<span style="font-weight:bold;">Burundi</span><br />Population : 30711737',
      },
      {
        id: "KH",
        value: 40511661,
        tooltip: '<span style="font-weight:bold;">Cambodia</span><br />Population : 40511661',
      },
      {
        id: "CM",
        value: 22079907,
        tooltip: '<span style="font-weight:bold;">Cameroon</span><br />Population : 22079907',
      },
      {
        id: "CA",
        value: 29964084,
        tooltip: '<span style="font-weight:bold;">Canada</span><br />Population : 29964084',
      },
      {
        id: "CV",
        value: 4878399,
        tooltip: '<span style="font-weight:bold;">Cape Verde</span><br />Population : 4878399',
      },
      {
        id: "CF",
        value: 58696634,
        tooltip: '<span style="font-weight:bold;">Central African Republic</span><br />Population : 58696634',
      },
      {
        id: "CL",
        value: 31285730,
        tooltip: '<span style="font-weight:bold;">Chile</span><br />Population : 31285730',
      },
      {
        id: "CN",
        value: 3867514,
        tooltip: '<span style="font-weight:bold;">China</span><br />Population : 3867514',
      },
      {
        id: "CY",
        value: 9346038,
        tooltip: '<span style="font-weight:bold;">Cyprus</span><br />Population : 9346038',
      },
      {
        id: "CO",
        value: 25288052,
        tooltip: '<span style="font-weight:bold;">Colombia</span><br />Population : 25288052',
      },
      {
        id: "KM",
        value: 47394092,
        tooltip: '<span style="font-weight:bold;">Comoros</span><br />Population : 47394092',
      },
      {
        id: "CG",
        value: 11347702,
        tooltip: '<span style="font-weight:bold;">Congo</span><br />Population : 11347702',
      },
      {
        id: "CD",
        value: 19780279,
        tooltip: '<span style="font-weight:bold;">Congo, The Democratic Republic Of The</span><br />Population : 19780279',
      },
      {
        id: "KP",
        value: 43239041,
        tooltip: "<span style=\"font-weight:bold;\">Korea, Democratic People's Republic Of</span><br />Population : 43239041",
      },
      {
        id: "KR",
        value: 31095618,
        tooltip: '<span style="font-weight:bold;">Korea, Republic Of</span><br />Population : 31095618',
      },
      {
        id: "CR",
        value: 20582773,
        tooltip: '<span style="font-weight:bold;">Costa Rica</span><br />Population : 20582773',
      },
      {
        id: "CI",
        value: 41796747,
        tooltip: "<span style=\"font-weight:bold;\">C\u00d4te D'ivoire</span><br />Population : 41796747",
      },
      {
        id: "HR",
        value: 5852725,
        tooltip: '<span style="font-weight:bold;">Croatia</span><br />Population : 5852725',
      },
      {
        id: "CU",
        value: 32930933,
        tooltip: '<span style="font-weight:bold;">Cuba</span><br />Population : 32930933',
      },
      {
        id: "DK",
        value: 29700851,
        tooltip: '<span style="font-weight:bold;">Denmark</span><br />Population : 29700851',
      },
      {
        id: "DJ",
        value: 51061066,
        tooltip: '<span style="font-weight:bold;">Djibouti</span><br />Population : 51061066',
      },
      {
        id: "DM",
        value: 16082229,
        tooltip: '<span style="font-weight:bold;">Dominica</span><br />Population : 16082229',
      },
      {
        id: "EG",
        value: 13590661,
        tooltip: '<span style="font-weight:bold;">Egypt</span><br />Population : 13590661',
      },
      {
        id: "AE",
        value: 6880062,
        tooltip: '<span style="font-weight:bold;">United Arab Emirates</span><br />Population : 6880062',
      },
      {
        id: "EC",
        value: 53188861,
        tooltip: '<span style="font-weight:bold;">Ecuador</span><br />Population : 53188861',
      },
      {
        id: "ER",
        value: 27130679,
        tooltip: '<span style="font-weight:bold;">Eritrea</span><br />Population : 27130679',
      },
      {
        id: "ES",
        value: 23615430,
        tooltip: '<span style="font-weight:bold;">Spain</span><br />Population : 23615430',
      },
      {
        id: "EE",
        value: 10148532,
        tooltip: '<span style="font-weight:bold;">Estonia</span><br />Population : 10148532',
      },
      {
        id: "US",
        value: 23845758,
        tooltip: '<span style="font-weight:bold;">United States</span><br />Population : 23845758',
      },
      {
        id: "ET",
        value: 22151199,
        tooltip: '<span style="font-weight:bold;">Ethiopia</span><br />Population : 22151199',
      },
      {
        id: "FJ",
        value: 23695862,
        tooltip: '<span style="font-weight:bold;">Fiji</span><br />Population : 23695862',
      },
      {
        id: "FI",
        value: 7684384,
        tooltip: '<span style="font-weight:bold;">Finland</span><br />Population : 7684384',
      },
      {
        id: "FR",
        value: 28547382,
        tooltip: '<span style="font-weight:bold;">France</span><br />Population : 28547382',
      },
      {
        id: "GA",
        value: 14246914,
        tooltip: '<span style="font-weight:bold;">Gabon</span><br />Population : 14246914',
      },
      {
        id: "GM",
        value: 4472583,
        tooltip: '<span style="font-weight:bold;">Gambia</span><br />Population : 4472583',
      },
      {
        id: "GE",
        value: 57515744,
        tooltip: '<span style="font-weight:bold;">Georgia</span><br />Population : 57515744',
      },
      {
        id: "GH",
        value: 42959357,
        tooltip: '<span style="font-weight:bold;">Ghana</span><br />Population : 42959357',
      },
      {
        id: "GR",
        value: 46470951,
        tooltip: '<span style="font-weight:bold;">Greece</span><br />Population : 46470951',
      },
      {
        id: "GD",
        value: 46436219,
        tooltip: '<span style="font-weight:bold;">Grenada</span><br />Population : 46436219',
      },
      {
        id: "GT",
        value: 8020736,
        tooltip: '<span style="font-weight:bold;">Guatemala</span><br />Population : 8020736',
      },
      {
        id: "GN",
        value: 12797308,
        tooltip: '<span style="font-weight:bold;">Guinea</span><br />Population : 12797308',
      },
      {
        id: "GQ",
        value: 12126431,
        tooltip: '<span style="font-weight:bold;">Equatorial Guinea</span><br />Population : 12126431',
      },
      {
        id: "GW",
        value: 20427392,
        tooltip: '<span style="font-weight:bold;">Guinea-bissau</span><br />Population : 20427392',
      },
      {
        id: "GY",
        value: 37027487,
        tooltip: '<span style="font-weight:bold;">Guyana</span><br />Population : 37027487',
      },
      {
        id: "HT",
        value: 33526862,
        tooltip: '<span style="font-weight:bold;">Haiti</span><br />Population : 33526862',
      },
      {
        id: "HN",
        value: 14166482,
        tooltip: '<span style="font-weight:bold;">Honduras</span><br />Population : 14166482',
      },
      {
        id: "HU",
        value: 6936731,
        tooltip: '<span style="font-weight:bold;">Hungary</span><br />Population : 6936731',
      },
      {
        id: "JM",
        value: 52814121,
        tooltip: '<span style="font-weight:bold;">Jamaica</span><br />Population : 52814121',
      },
      {
        id: "JP",
        value: 50863642,
        tooltip: '<span style="font-weight:bold;">Japan</span><br />Population : 50863642',
      },
      {
        id: "MH",
        value: 5794229,
        tooltip: '<span style="font-weight:bold;">Marshall Islands</span><br />Population : 5794229',
      },
      {
        id: "PW",
        value: 56504859,
        tooltip: '<span style="font-weight:bold;">Palau</span><br />Population : 56504859',
      },
      {
        id: "SB",
        value: 53508762,
        tooltip: '<span style="font-weight:bold;">Solomon Islands</span><br />Population : 53508762',
      },
      {
        id: "IN",
        value: 40473273,
        tooltip: '<span style="font-weight:bold;">India</span><br />Population : 40473273',
      },
      {
        id: "ID",
        value: 30062796,
        tooltip: '<span style="font-weight:bold;">Indonesia</span><br />Population : 30062796',
      },
      {
        id: "JO",
        value: 10022400,
        tooltip: '<span style="font-weight:bold;">Jordan</span><br />Population : 10022400',
      },
      {
        id: "IR",
        value: 7289535,
        tooltip: '<span style="font-weight:bold;">Iran, Islamic Republic Of</span><br />Population : 7289535',
      },
      {
        id: "IQ",
        value: 7971380,
        tooltip: '<span style="font-weight:bold;">Iraq</span><br />Population : 7971380',
      },
      {
        id: "IE",
        value: 40175308,
        tooltip: '<span style="font-weight:bold;">Ireland</span><br />Population : 40175308',
      },
      {
        id: "IS",
        value: 37829981,
        tooltip: '<span style="font-weight:bold;">Iceland</span><br />Population : 37829981',
      },
      {
        id: "IL",
        value: 32084567,
        tooltip: '<span style="font-weight:bold;">Israel</span><br />Population : 32084567',
      },
      {
        id: "IT",
        value: 48823590,
        tooltip: '<span style="font-weight:bold;">Italy</span><br />Population : 48823590',
      },
      {
        id: "KZ",
        value: 19284891,
        tooltip: '<span style="font-weight:bold;">Kazakhstan</span><br />Population : 19284891',
      },
      {
        id: "KE",
        value: 40718225,
        tooltip: '<span style="font-weight:bold;">Kenya</span><br />Population : 40718225',
      },
      {
        id: "KG",
        value: 36171982,
        tooltip: '<span style="font-weight:bold;">Kyrgyzstan</span><br />Population : 36171982',
      },
      {
        id: "KI",
        value: 48845526,
        tooltip: '<span style="font-weight:bold;">Kiribati</span><br />Population : 48845526',
      },
      {
        id: "KW",
        value: 40394669,
        tooltip: '<span style="font-weight:bold;">Kuwait</span><br />Population : 40394669',
      },
      {
        id: "LA",
        value: 9327758,
        tooltip: "<span style=\"font-weight:bold;\">Lao People's Democratic Republic</span><br />Population : 9327758",
      },
      {
        id: "LS",
        value: 17679904,
        tooltip: '<span style="font-weight:bold;">Lesotho</span><br />Population : 17679904',
      },
      {
        id: "LV",
        value: 43602814,
        tooltip: '<span style="font-weight:bold;">Latvia</span><br />Population : 43602814',
      },
      {
        id: "LB",
        value: 26757767,
        tooltip: '<span style="font-weight:bold;">Lebanon</span><br />Population : 26757767',
      },
      {
        id: "LR",
        value: 24149206,
        tooltip: '<span style="font-weight:bold;">Liberia</span><br />Population : 24149206',
      },
      {
        id: "LY",
        value: 4686459,
        tooltip: '<span style="font-weight:bold;">Libya</span><br />Population : 4686459',
      },
      {
        id: "LI",
        value: 38711078,
        tooltip: '<span style="font-weight:bold;">Liechtenstein</span><br />Population : 38711078',
      },
      {
        id: "LT",
        value: 51377311,
        tooltip: '<span style="font-weight:bold;">Lithuania</span><br />Population : 51377311',
      },
      {
        id: "LU",
        value: 15923193,
        tooltip: '<span style="font-weight:bold;">Luxembourg</span><br />Population : 15923193',
      },
      {
        id: "MK",
        value: 55219773,
        tooltip: '<span style="font-weight:bold;">Macedonia, The Former Yugoslav Republic Of</span><br />Population : 55219773',
      },
      {
        id: "MG",
        value: 9835943,
        tooltip: '<span style="font-weight:bold;">Madagascar</span><br />Population : 9835943',
      },
      {
        id: "MY",
        value: 37506424,
        tooltip: '<span style="font-weight:bold;">Malaysia</span><br />Population : 37506424',
      },
      {
        id: "MW",
        value: 5240344,
        tooltip: '<span style="font-weight:bold;">Malawi</span><br />Population : 5240344',
      },
      {
        id: "MV",
        value: 17657968,
        tooltip: '<span style="font-weight:bold;">Maldives</span><br />Population : 17657968',
      },
      {
        id: "ML",
        value: 22493036,
        tooltip: '<span style="font-weight:bold;">Mali</span><br />Population : 22493036',
      },
      {
        id: "MT",
        value: 58148234,
        tooltip: '<span style="font-weight:bold;">Malta</span><br />Population : 58148234',
      },
      {
        id: "MA",
        value: 42641284,
        tooltip: '<span style="font-weight:bold;">Morocco</span><br />Population : 42641284',
      },
      {
        id: "MU",
        value: 9929171,
        tooltip: '<span style="font-weight:bold;">Mauritius</span><br />Population : 9929171',
      },
      {
        id: "MR",
        value: 52347980,
        tooltip: '<span style="font-weight:bold;">Mauritania</span><br />Population : 52347980',
      },
      {
        id: "MX",
        value: 36555863,
        tooltip: '<span style="font-weight:bold;">Mexico</span><br />Population : 36555863',
      },
      {
        id: "FM",
        value: 28916638,
        tooltip: '<span style="font-weight:bold;">Micronesia, Federated States Of</span><br />Population : 28916638',
      },
      {
        id: "MD",
        value: 211508,
        tooltip: '<span style="font-weight:bold;">Moldova, Republic Of</span><br />Population : 211508',
      },
      {
        id: "MC",
        value: 45116400,
        tooltip: '<span style="font-weight:bold;">Monaco</span><br />Population : 45116400',
      },
      {
        id: "MN",
        value: 45732437,
        tooltip: '<span style="font-weight:bold;">Mongolia</span><br />Population : 45732437',
      },
      {
        id: "ME",
        value: 14607031,
        tooltip: '<span style="font-weight:bold;">Montenegro</span><br />Population : 14607031',
      },
      {
        id: "MZ",
        value: 46533103,
        tooltip: '<span style="font-weight:bold;">Mozambique</span><br />Population : 46533103',
      },
      {
        id: "NA",
        value: 36363922,
        tooltip: '<span style="font-weight:bold;">Namibia</span><br />Population : 36363922',
      },
      {
        id: "NP",
        value: 8931082,
        tooltip: '<span style="font-weight:bold;">Nepal</span><br />Population : 8931082',
      },
      {
        id: "NI",
        value: 20303088,
        tooltip: '<span style="font-weight:bold;">Nicaragua</span><br />Population : 20303088',
      },
      {
        id: "NE",
        value: 57172080,
        tooltip: '<span style="font-weight:bold;">Niger</span><br />Population : 57172080',
      },
      {
        id: "NG",
        value: 31706171,
        tooltip: '<span style="font-weight:bold;">Nigeria</span><br />Population : 31706171',
      },
      {
        id: "NO",
        value: 59054923,
        tooltip: '<span style="font-weight:bold;">Norway</span><br />Population : 59054923',
      },
      {
        id: "NZ",
        value: 36645435,
        tooltip: '<span style="font-weight:bold;">New Zealand</span><br />Population : 36645435',
      },
      {
        id: "OM",
        value: 30256564,
        tooltip: '<span style="font-weight:bold;">Oman</span><br />Population : 30256564',
      },
      {
        id: "UG",
        value: 6808770,
        tooltip: '<span style="font-weight:bold;">Uganda</span><br />Population : 6808770',
      },
      {
        id: "UZ",
        value: 59457084,
        tooltip: '<span style="font-weight:bold;">Uzbekistan</span><br />Population : 59457084',
      },
      {
        id: "PK",
        value: 24324695,
        tooltip: '<span style="font-weight:bold;">Pakistan</span><br />Population : 24324695',
      },
      {
        id: "PS",
        value: 53764682,
        tooltip: '<span style="font-weight:bold;">Palestine, State Of</span><br />Population : 53764682',
      },
      {
        id: "PA",
        value: 27187347,
        tooltip: '<span style="font-weight:bold;">Panama</span><br />Population : 27187347',
      },
      {
        id: "PG",
        value: 23240689,
        tooltip: '<span style="font-weight:bold;">Papua New Guinea</span><br />Population : 23240689',
      },
      {
        id: "PY",
        value: 33881494,
        tooltip: '<span style="font-weight:bold;">Paraguay</span><br />Population : 33881494',
      },
      {
        id: "NL",
        value: 6024557,
        tooltip: '<span style="font-weight:bold;">Netherlands</span><br />Population : 6024557',
      },
      {
        id: "PE",
        value: 8607525,
        tooltip: '<span style="font-weight:bold;">Peru</span><br />Population : 8607525',
      },
      {
        id: "PH",
        value: 53358866,
        tooltip: '<span style="font-weight:bold;">Philippines</span><br />Population : 53358866',
      },
      {
        id: "PL",
        value: 26006457,
        tooltip: '<span style="font-weight:bold;">Poland</span><br />Population : 26006457',
      },
      {
        id: "PT",
        value: 34914316,
        tooltip: '<span style="font-weight:bold;">Portugal</span><br />Population : 34914316',
      },
      {
        id: "QA",
        value: 16584930,
        tooltip: '<span style="font-weight:bold;">Qatar</span><br />Population : 16584930',
      },
      {
        id: "DO",
        value: 43114737,
        tooltip: '<span style="font-weight:bold;">Dominican Republic</span><br />Population : 43114737',
      },
      {
        id: "RO",
        value: 51240210,
        tooltip: '<span style="font-weight:bold;">Romania</span><br />Population : 51240210',
      },
      {
        id: "GB",
        value: 18762082,
        tooltip: '<span style="font-weight:bold;">United Kingdom</span><br />Population : 18762082',
      },
      {
        id: "RU",
        value: 26785187,
        tooltip: '<span style="font-weight:bold;">Russian Federation</span><br />Population : 26785187',
      },
      {
        id: "RW",
        value: 35561429,
        tooltip: '<span style="font-weight:bold;">Rwanda</span><br />Population : 35561429',
      },
      {
        id: "KN",
        value: 10373376,
        tooltip: '<span style="font-weight:bold;">Saint Kitts And Nevis</span><br />Population : 10373376',
      },
      {
        id: "SM",
        value: 45545981,
        tooltip: '<span style="font-weight:bold;">San Marino</span><br />Population : 45545981',
      },
      {
        id: "VC",
        value: 44823920,
        tooltip: '<span style="font-weight:bold;">Saint Vincent And The Grenadines</span><br />Population : 44823920',
      },
      {
        id: "LC",
        value: 43802066,
        tooltip: '<span style="font-weight:bold;">Saint Lucia</span><br />Population : 43802066',
      },
      {
        id: "SV",
        value: 13846582,
        tooltip: '<span style="font-weight:bold;">El Salvador</span><br />Population : 13846582',
      },
      {
        id: "WS",
        value: 53494138,
        tooltip: '<span style="font-weight:bold;">Samoa</span><br />Population : 53494138',
      },
      {
        id: "ST",
        value: 46366754,
        tooltip: '<span style="font-weight:bold;">Sao Tome And Principe</span><br />Population : 46366754',
      },
      {
        id: "SN",
        value: 50989774,
        tooltip: '<span style="font-weight:bold;">Senegal</span><br />Population : 50989774',
      },
      {
        id: "RS",
        value: 22350452,
        tooltip: '<span style="font-weight:bold;">Serbia</span><br />Population : 22350452',
      },
      {
        id: "SC",
        value: 10784677,
        tooltip: '<span style="font-weight:bold;">Seychelles</span><br />Population : 10784677',
      },
      {
        id: "SL",
        value: 37029315,
        tooltip: '<span style="font-weight:bold;">Sierra Leone</span><br />Population : 37029315',
      },
      {
        id: "SG",
        value: 10327676,
        tooltip: '<span style="font-weight:bold;">Singapore</span><br />Population : 10327676',
      },
      {
        id: "SK",
        value: 26525610,
        tooltip: '<span style="font-weight:bold;">Slovakia</span><br />Population : 26525610',
      },
      {
        id: "SI",
        value: 35345725,
        tooltip: '<span style="font-weight:bold;">Slovenia</span><br />Population : 35345725',
      },
      {
        id: "SO",
        value: 52377228,
        tooltip: '<span style="font-weight:bold;">Somalia</span><br />Population : 52377228',
      },
      {
        id: "SD",
        value: 24768899,
        tooltip: '<span style="font-weight:bold;">Sudan</span><br />Population : 24768899',
      },
      {
        id: "SS",
        value: 46962683,
        tooltip: '<span style="font-weight:bold;">South Sudan</span><br />Population : 46962683',
      },
      {
        id: "LK",
        value: 35455405,
        tooltip: '<span style="font-weight:bold;">Sri Lanka</span><br />Population : 35455405',
      },
      {
        id: "SE",
        value: 38126117,
        tooltip: '<span style="font-weight:bold;">Sweden</span><br />Population : 38126117',
      },
      {
        id: "CH",
        value: 47516568,
        tooltip: '<span style="font-weight:bold;">Switzerland</span><br />Population : 47516568',
      },
      {
        id: "SR",
        value: 14402295,
        tooltip: '<span style="font-weight:bold;">Suriname</span><br />Population : 14402295',
      },
      {
        id: "SZ",
        value: 9241842,
        tooltip: '<span style="font-weight:bold;">Swaziland</span><br />Population : 9241842',
      },
      {
        id: "SY",
        value: 29841608,
        tooltip: '<span style="font-weight:bold;">Syrian Arab Republic</span><br />Population : 29841608',
      },
      {
        id: "TJ",
        value: 1823806,
        tooltip: '<span style="font-weight:bold;">Tajikistan</span><br />Population : 1823806',
      },
      {
        id: "TZ",
        value: 9335070,
        tooltip: '<span style="font-weight:bold;">Tanzania, United Republic Of</span><br />Population : 9335070',
      },
      {
        id: "TD",
        value: 44683164,
        tooltip: '<span style="font-weight:bold;">Chad</span><br />Population : 44683164',
      },
      {
        id: "CZ",
        value: 33139325,
        tooltip: '<span style="font-weight:bold;">Czech Republic</span><br />Population : 33139325',
      },
      {
        id: "TH",
        value: 20593741,
        tooltip: '<span style="font-weight:bold;">Thailand</span><br />Population : 20593741',
      },
      {
        id: "TL",
        value: 22401636,
        tooltip: '<span style="font-weight:bold;">Timor-leste</span><br />Population : 22401636',
      },
      {
        id: "TG",
        value: 20107492,
        tooltip: '<span style="font-weight:bold;">Togo</span><br />Population : 20107492',
      },
      {
        id: "TO",
        value: 23684894,
        tooltip: '<span style="font-weight:bold;">Tonga</span><br />Population : 23684894',
      },
      {
        id: "TT",
        value: 27079495,
        tooltip: '<span style="font-weight:bold;">Trinidad And Tobago</span><br />Population : 27079495',
      },
      {
        id: "TN",
        value: 14292614,
        tooltip: '<span style="font-weight:bold;">Tunisia</span><br />Population : 14292614',
      },
      {
        id: "TM",
        value: 23492953,
        tooltip: '<span style="font-weight:bold;">Turkmenistan</span><br />Population : 23492953',
      },
      {
        id: "TR",
        value: 7093939,
        tooltip: '<span style="font-weight:bold;">Turkey</span><br />Population : 7093939',
      },
      {
        id: "TV",
        value: 34384195,
        tooltip: '<span style="font-weight:bold;">Tuvalu</span><br />Population : 34384195',
      },
      {
        id: "VU",
        value: 35548633,
        tooltip: '<span style="font-weight:bold;">Vanuatu</span><br />Population : 35548633',
      },
      {
        id: "VE",
        value: 52967673,
        tooltip: '<span style="font-weight:bold;">Venezuela, Bolivarian Republic Of</span><br />Population : 52967673',
      },
      {
        id: "VN",
        value: 18932086,
        tooltip: '<span style="font-weight:bold;">Viet Nam</span><br />Population : 18932086',
      },
      {
        id: "UA",
        value: 25660965,
        tooltip: '<span style="font-weight:bold;">Ukraine</span><br />Population : 25660965',
      },
      {
        id: "UY",
        value: 46860315,
        tooltip: '<span style="font-weight:bold;">Uruguay</span><br />Population : 46860315',
      },
      {
        id: "YE",
        value: 16809775,
        tooltip: '<span style="font-weight:bold;">Yemen</span><br />Population : 16809775',
      },
      {
        id: "ZM",
        value: 4914959,
        tooltip: '<span style="font-weight:bold;">Zambia</span><br />Population : 4914959',
      },
      {
        id: "ZW",
        value: 14012930,
        tooltip: '<span style="font-weight:bold;">Zimbabwe</span><br />Population : 14012930',
      },
    ],
  },
  2018: {
    areas: [
      {
        id: "AF",
        value: 9658627,
        tooltip: '<span style="font-weight:bold;">Afghanistan</span><br />Population : 9658627',
      },
      {
        id: "ZA",
        value: 11627386,
        tooltip: '<span style="font-weight:bold;">South Africa</span><br />Population : 11627386',
      },
      {
        id: "AL",
        value: 4404946,
        tooltip: '<span style="font-weight:bold;">Albania</span><br />Population : 4404946',
      },
      {
        id: "DZ",
        value: 17385595,
        tooltip: '<span style="font-weight:bold;">Algeria</span><br />Population : 17385595',
      },
      {
        id: "DE",
        value: 4971627,
        tooltip: '<span style="font-weight:bold;">Germany</span><br />Population : 4971627',
      },
      {
        id: "AD",
        value: 13638189,
        tooltip: '<span style="font-weight:bold;">Andorra</span><br />Population : 13638189',
      },
      {
        id: "AO",
        value: 2701248,
        tooltip: '<span style="font-weight:bold;">Angola</span><br />Population : 2701248',
      },
      {
        id: "AG",
        value: 15126184,
        tooltip: '<span style="font-weight:bold;">Antigua And Barbuda</span><br />Population : 15126184',
      },
      {
        id: "SA",
        value: 46964511,
        tooltip: '<span style="font-weight:bold;">Saudi Arabia</span><br />Population : 46964511',
      },
      {
        id: "AR",
        value: 12256219,
        tooltip: '<span style="font-weight:bold;">Argentina</span><br />Population : 12256219',
      },
      {
        id: "AM",
        value: 50485245,
        tooltip: '<span style="font-weight:bold;">Armenia</span><br />Population : 50485245',
      },
      {
        id: "AU",
        value: 16025561,
        tooltip: '<span style="font-weight:bold;">Australia</span><br />Population : 16025561',
      },
      {
        id: "AT",
        value: 13965402,
        tooltip: '<span style="font-weight:bold;">Austria</span><br />Population : 13965402',
      },
      {
        id: "AZ",
        value: 43047101,
        tooltip: '<span style="font-weight:bold;">Azerbaijan</span><br />Population : 43047101',
      },
      {
        id: "BS",
        value: 11110061,
        tooltip: '<span style="font-weight:bold;">Bahamas</span><br />Population : 11110061',
      },
      {
        id: "BH",
        value: 40674353,
        tooltip: '<span style="font-weight:bold;">Bahrain</span><br />Population : 40674353',
      },
      {
        id: "BD",
        value: 53852427,
        tooltip: '<span style="font-weight:bold;">Bangladesh</span><br />Population : 53852427',
      },
      {
        id: "BB",
        value: 51726459,
        tooltip: '<span style="font-weight:bold;">Barbados</span><br />Population : 51726459',
      },
      {
        id: "BE",
        value: 17478824,
        tooltip: '<span style="font-weight:bold;">Belgium</span><br />Population : 17478824',
      },
      {
        id: "BZ",
        value: 19813183,
        tooltip: '<span style="font-weight:bold;">Belize</span><br />Population : 19813183',
      },
      {
        id: "BJ",
        value: 44953708,
        tooltip: '<span style="font-weight:bold;">Benin</span><br />Population : 44953708',
      },
      {
        id: "BT",
        value: 13959918,
        tooltip: '<span style="font-weight:bold;">Bhutan</span><br />Population : 13959918',
      },
      {
        id: "BY",
        value: 52744657,
        tooltip: '<span style="font-weight:bold;">Belarus</span><br />Population : 52744657',
      },
      {
        id: "MM",
        value: 33932678,
        tooltip: '<span style="font-weight:bold;">Myanmar</span><br />Population : 33932678',
      },
      {
        id: "BO",
        value: 15347372,
        tooltip: '<span style="font-weight:bold;">Bolivia, Plurinational State Of</span><br />Population : 15347372',
      },
      {
        id: "BA",
        value: 55163105,
        tooltip: '<span style="font-weight:bold;">Bosnia And Herzegovina</span><br />Population : 55163105',
      },
      {
        id: "BW",
        value: 10210684,
        tooltip: '<span style="font-weight:bold;">Botswana</span><br />Population : 10210684',
      },
      {
        id: "BR",
        value: 13773462,
        tooltip: '<span style="font-weight:bold;">Brazil</span><br />Population : 13773462',
      },
      {
        id: "BN",
        value: 23061545,
        tooltip: '<span style="font-weight:bold;">Brunei Darussalam</span><br />Population : 23061545',
      },
      {
        id: "BG",
        value: 31201642,
        tooltip: '<span style="font-weight:bold;">Bulgaria</span><br />Population : 31201642',
      },
      {
        id: "BF",
        value: 52730033,
        tooltip: '<span style="font-weight:bold;">Burkina Faso</span><br />Population : 52730033',
      },
      {
        id: "BI",
        value: 39826160,
        tooltip: '<span style="font-weight:bold;">Burundi</span><br />Population : 39826160',
      },
      {
        id: "KH",
        value: 36274350,
        tooltip: '<span style="font-weight:bold;">Cambodia</span><br />Population : 36274350',
      },
      {
        id: "CM",
        value: 7591156,
        tooltip: '<span style="font-weight:bold;">Cameroon</span><br />Population : 7591156',
      },
      {
        id: "CA",
        value: 13705826,
        tooltip: '<span style="font-weight:bold;">Canada</span><br />Population : 13705826',
      },
      {
        id: "CV",
        value: 42831397,
        tooltip: '<span style="font-weight:bold;">Cape Verde</span><br />Population : 42831397',
      },
      {
        id: "CF",
        value: 53113913,
        tooltip: '<span style="font-weight:bold;">Central African Republic</span><br />Population : 53113913',
      },
      {
        id: "CL",
        value: 19897272,
        tooltip: '<span style="font-weight:bold;">Chile</span><br />Population : 19897272',
      },
      {
        id: "CN",
        value: 55991190,
        tooltip: '<span style="font-weight:bold;">China</span><br />Population : 55991190',
      },
      {
        id: "CY",
        value: 43379798,
        tooltip: '<span style="font-weight:bold;">Cyprus</span><br />Population : 43379798',
      },
      {
        id: "CO",
        value: 41758359,
        tooltip: '<span style="font-weight:bold;">Colombia</span><br />Population : 41758359',
      },
      {
        id: "KM",
        value: 13835614,
        tooltip: '<span style="font-weight:bold;">Comoros</span><br />Population : 13835614',
      },
      {
        id: "CG",
        value: 12989248,
        tooltip: '<span style="font-weight:bold;">Congo</span><br />Population : 12989248',
      },
      {
        id: "CD",
        value: 32111987,
        tooltip: '<span style="font-weight:bold;">Congo, The Democratic Republic Of The</span><br />Population : 32111987',
      },
      {
        id: "KP",
        value: 335812,
        tooltip: "<span style=\"font-weight:bold;\">Korea, Democratic People's Republic Of</span><br />Population : 335812",
      },
      {
        id: "KR",
        value: 24971808,
        tooltip: '<span style="font-weight:bold;">Korea, Republic Of</span><br />Population : 24971808',
      },
      {
        id: "CR",
        value: 47553128,
        tooltip: '<span style="font-weight:bold;">Costa Rica</span><br />Population : 47553128',
      },
      {
        id: "CI",
        value: 29618591,
        tooltip: "<span style=\"font-weight:bold;\">C\u00d4te D'ivoire</span><br />Population : 29618591",
      },
      {
        id: "HR",
        value: 16824399,
        tooltip: '<span style="font-weight:bold;">Croatia</span><br />Population : 16824399',
      },
      {
        id: "CU",
        value: 58921479,
        tooltip: '<span style="font-weight:bold;">Cuba</span><br />Population : 58921479',
      },
      {
        id: "DK",
        value: 52985953,
        tooltip: '<span style="font-weight:bold;">Denmark</span><br />Population : 52985953',
      },
      {
        id: "DJ",
        value: 26540234,
        tooltip: '<span style="font-weight:bold;">Djibouti</span><br />Population : 26540234',
      },
      {
        id: "DM",
        value: 29452243,
        tooltip: '<span style="font-weight:bold;">Dominica</span><br />Population : 29452243',
      },
      {
        id: "EG",
        value: 31450250,
        tooltip: '<span style="font-weight:bold;">Egypt</span><br />Population : 31450250',
      },
      {
        id: "AE",
        value: 12440847,
        tooltip: '<span style="font-weight:bold;">United Arab Emirates</span><br />Population : 12440847',
      },
      {
        id: "EC",
        value: 43467542,
        tooltip: '<span style="font-weight:bold;">Ecuador</span><br />Population : 43467542',
      },
      {
        id: "ER",
        value: 6397470,
        tooltip: '<span style="font-weight:bold;">Eritrea</span><br />Population : 6397470',
      },
      {
        id: "ES",
        value: 8073748,
        tooltip: '<span style="font-weight:bold;">Spain</span><br />Population : 8073748',
      },
      {
        id: "EE",
        value: 58820939,
        tooltip: '<span style="font-weight:bold;">Estonia</span><br />Population : 58820939',
      },
      {
        id: "US",
        value: 11141137,
        tooltip: '<span style="font-weight:bold;">United States</span><br />Population : 11141137',
      },
      {
        id: "ET",
        value: 5688205,
        tooltip: '<span style="font-weight:bold;">Ethiopia</span><br />Population : 5688205',
      },
      {
        id: "FJ",
        value: 24357599,
        tooltip: '<span style="font-weight:bold;">Fiji</span><br />Population : 24357599',
      },
      {
        id: "FI",
        value: 55479349,
        tooltip: '<span style="font-weight:bold;">Finland</span><br />Population : 55479349',
      },
      {
        id: "FR",
        value: 10051648,
        tooltip: '<span style="font-weight:bold;">France</span><br />Population : 10051648',
      },
      {
        id: "GA",
        value: 55402573,
        tooltip: '<span style="font-weight:bold;">Gabon</span><br />Population : 55402573',
      },
      {
        id: "GM",
        value: 26017425,
        tooltip: '<span style="font-weight:bold;">Gambia</span><br />Population : 26017425',
      },
      {
        id: "GE",
        value: 15519204,
        tooltip: '<span style="font-weight:bold;">Georgia</span><br />Population : 15519204',
      },
      {
        id: "GH",
        value: 30839697,
        tooltip: '<span style="font-weight:bold;">Ghana</span><br />Population : 30839697',
      },
      {
        id: "GR",
        value: 33868698,
        tooltip: '<span style="font-weight:bold;">Greece</span><br />Population : 33868698',
      },
      {
        id: "GD",
        value: 48618854,
        tooltip: '<span style="font-weight:bold;">Grenada</span><br />Population : 48618854',
      },
      {
        id: "GT",
        value: 41893631,
        tooltip: '<span style="font-weight:bold;">Guatemala</span><br />Population : 41893631',
      },
      {
        id: "GN",
        value: 34195911,
        tooltip: '<span style="font-weight:bold;">Guinea</span><br />Population : 34195911',
      },
      {
        id: "GQ",
        value: 29064706,
        tooltip: '<span style="font-weight:bold;">Equatorial Guinea</span><br />Population : 29064706',
      },
      {
        id: "GW",
        value: 37877509,
        tooltip: '<span style="font-weight:bold;">Guinea-bissau</span><br />Population : 37877509',
      },
      {
        id: "GY",
        value: 27905753,
        tooltip: '<span style="font-weight:bold;">Guyana</span><br />Population : 27905753',
      },
      {
        id: "HT",
        value: 10760913,
        tooltip: '<span style="font-weight:bold;">Haiti</span><br />Population : 10760913',
      },
      {
        id: "HN",
        value: 39118723,
        tooltip: '<span style="font-weight:bold;">Honduras</span><br />Population : 39118723',
      },
      {
        id: "HU",
        value: 29359015,
        tooltip: '<span style="font-weight:bold;">Hungary</span><br />Population : 29359015',
      },
      {
        id: "JM",
        value: 16608694,
        tooltip: '<span style="font-weight:bold;">Jamaica</span><br />Population : 16608694',
      },
      {
        id: "JP",
        value: 41025330,
        tooltip: '<span style="font-weight:bold;">Japan</span><br />Population : 41025330',
      },
      {
        id: "MH",
        value: 32208871,
        tooltip: '<span style="font-weight:bold;">Marshall Islands</span><br />Population : 32208871',
      },
      {
        id: "PW",
        value: 28678998,
        tooltip: '<span style="font-weight:bold;">Palau</span><br />Population : 28678998',
      },
      {
        id: "SB",
        value: 21105582,
        tooltip: '<span style="font-weight:bold;">Solomon Islands</span><br />Population : 21105582',
      },
      {
        id: "IN",
        value: 55729786,
        tooltip: '<span style="font-weight:bold;">India</span><br />Population : 55729786',
      },
      {
        id: "ID",
        value: 6463278,
        tooltip: '<span style="font-weight:bold;">Indonesia</span><br />Population : 6463278',
      },
      {
        id: "JO",
        value: 11503082,
        tooltip: '<span style="font-weight:bold;">Jordan</span><br />Population : 11503082',
      },
      {
        id: "IR",
        value: 24549539,
        tooltip: '<span style="font-weight:bold;">Iran, Islamic Republic Of</span><br />Population : 24549539',
      },
      {
        id: "IQ",
        value: 15564905,
        tooltip: '<span style="font-weight:bold;">Iraq</span><br />Population : 15564905',
      },
      {
        id: "IE",
        value: 49860068,
        tooltip: '<span style="font-weight:bold;">Ireland</span><br />Population : 49860068',
      },
      {
        id: "IS",
        value: 43346894,
        tooltip: '<span style="font-weight:bold;">Iceland</span><br />Population : 43346894',
      },
      {
        id: "IL",
        value: 40043692,
        tooltip: '<span style="font-weight:bold;">Israel</span><br />Population : 40043692',
      },
      {
        id: "IT",
        value: 30971313,
        tooltip: '<span style="font-weight:bold;">Italy</span><br />Population : 30971313',
      },
      {
        id: "KZ",
        value: 40727365,
        tooltip: '<span style="font-weight:bold;">Kazakhstan</span><br />Population : 40727365',
      },
      {
        id: "KE",
        value: 39976056,
        tooltip: '<span style="font-weight:bold;">Kenya</span><br />Population : 39976056',
      },
      {
        id: "KG",
        value: 50741166,
        tooltip: '<span style="font-weight:bold;">Kyrgyzstan</span><br />Population : 50741166',
      },
      {
        id: "KI",
        value: 2739636,
        tooltip: '<span style="font-weight:bold;">Kiribati</span><br />Population : 2739636',
      },
      {
        id: "KW",
        value: 7143295,
        tooltip: '<span style="font-weight:bold;">Kuwait</span><br />Population : 7143295',
      },
      {
        id: "LA",
        value: 7006195,
        tooltip: "<span style=\"font-weight:bold;\">Lao People's Democratic Republic</span><br />Population : 7006195",
      },
      {
        id: "LS",
        value: 9845083,
        tooltip: '<span style="font-weight:bold;">Lesotho</span><br />Population : 9845083',
      },
      {
        id: "LV",
        value: 41310498,
        tooltip: '<span style="font-weight:bold;">Latvia</span><br />Population : 41310498',
      },
      {
        id: "LB",
        value: 7135983,
        tooltip: '<span style="font-weight:bold;">Lebanon</span><br />Population : 7135983',
      },
      {
        id: "LR",
        value: 39902936,
        tooltip: '<span style="font-weight:bold;">Liberia</span><br />Population : 39902936',
      },
      {
        id: "LY",
        value: 20308572,
        tooltip: '<span style="font-weight:bold;">Libya</span><br />Population : 20308572',
      },
      {
        id: "LI",
        value: 47474524,
        tooltip: '<span style="font-weight:bold;">Liechtenstein</span><br />Population : 47474524',
      },
      {
        id: "LT",
        value: 8883554,
        tooltip: '<span style="font-weight:bold;">Lithuania</span><br />Population : 8883554',
      },
      {
        id: "LU",
        value: 24481903,
        tooltip: '<span style="font-weight:bold;">Luxembourg</span><br />Population : 24481903',
      },
      {
        id: "MK",
        value: 35334757,
        tooltip: '<span style="font-weight:bold;">Macedonia, The Former Yugoslav Republic Of</span><br />Population : 35334757',
      },
      {
        id: "MG",
        value: 11872339,
        tooltip: '<span style="font-weight:bold;">Madagascar</span><br />Population : 11872339',
      },
      {
        id: "MY",
        value: 10514132,
        tooltip: '<span style="font-weight:bold;">Malaysia</span><br />Population : 10514132',
      },
      {
        id: "MW",
        value: 56208722,
        tooltip: '<span style="font-weight:bold;">Malawi</span><br />Population : 56208722',
      },
      {
        id: "MV",
        value: 38076761,
        tooltip: '<span style="font-weight:bold;">Maldives</span><br />Population : 38076761',
      },
      {
        id: "ML",
        value: 14994568,
        tooltip: '<span style="font-weight:bold;">Mali</span><br />Population : 14994568',
      },
      {
        id: "MT",
        value: 40105844,
        tooltip: '<span style="font-weight:bold;">Malta</span><br />Population : 40105844',
      },
      {
        id: "MA",
        value: 20899017,
        tooltip: '<span style="font-weight:bold;">Morocco</span><br />Population : 20899017',
      },
      {
        id: "MU",
        value: 41637711,
        tooltip: '<span style="font-weight:bold;">Mauritius</span><br />Population : 41637711',
      },
      {
        id: "MR",
        value: 47481836,
        tooltip: '<span style="font-weight:bold;">Mauritania</span><br />Population : 47481836',
      },
      {
        id: "MX",
        value: 35886813,
        tooltip: '<span style="font-weight:bold;">Mexico</span><br />Population : 35886813',
      },
      {
        id: "FM",
        value: 14018414,
        tooltip: '<span style="font-weight:bold;">Micronesia, Federated States Of</span><br />Population : 14018414',
      },
      {
        id: "MD",
        value: 29170731,
        tooltip: '<span style="font-weight:bold;">Moldova, Republic Of</span><br />Population : 29170731',
      },
      {
        id: "MC",
        value: 10124768,
        tooltip: '<span style="font-weight:bold;">Monaco</span><br />Population : 10124768',
      },
      {
        id: "MN",
        value: 25935165,
        tooltip: '<span style="font-weight:bold;">Mongolia</span><br />Population : 25935165',
      },
      {
        id: "ME",
        value: 41182538,
        tooltip: '<span style="font-weight:bold;">Montenegro</span><br />Population : 41182538',
      },
      {
        id: "MZ",
        value: 13778946,
        tooltip: '<span style="font-weight:bold;">Mozambique</span><br />Population : 13778946',
      },
      {
        id: "NA",
        value: 13363989,
        tooltip: '<span style="font-weight:bold;">Namibia</span><br />Population : 13363989',
      },
      {
        id: "NP",
        value: 8379025,
        tooltip: '<span style="font-weight:bold;">Nepal</span><br />Population : 8379025',
      },
      {
        id: "NI",
        value: 18157013,
        tooltip: '<span style="font-weight:bold;">Nicaragua</span><br />Population : 18157013',
      },
      {
        id: "NE",
        value: 38515482,
        tooltip: '<span style="font-weight:bold;">Niger</span><br />Population : 38515482',
      },
      {
        id: "NG",
        value: 17890124,
        tooltip: '<span style="font-weight:bold;">Nigeria</span><br />Population : 17890124',
      },
      {
        id: "NO",
        value: 11296518,
        tooltip: '<span style="font-weight:bold;">Norway</span><br />Population : 11296518',
      },
      {
        id: "NZ",
        value: 10457464,
        tooltip: '<span style="font-weight:bold;">New Zealand</span><br />Population : 10457464',
      },
      {
        id: "OM",
        value: 56583463,
        tooltip: '<span style="font-weight:bold;">Oman</span><br />Population : 56583463',
      },
      {
        id: "UG",
        value: 14343799,
        tooltip: '<span style="font-weight:bold;">Uganda</span><br />Population : 14343799',
      },
      {
        id: "UZ",
        value: 32815768,
        tooltip: '<span style="font-weight:bold;">Uzbekistan</span><br />Population : 32815768',
      },
      {
        id: "PK",
        value: 53649518,
        tooltip: '<span style="font-weight:bold;">Pakistan</span><br />Population : 53649518',
      },
      {
        id: "PS",
        value: 51136014,
        tooltip: '<span style="font-weight:bold;">Palestine, State Of</span><br />Population : 51136014',
      },
      {
        id: "PA",
        value: 23315637,
        tooltip: '<span style="font-weight:bold;">Panama</span><br />Population : 23315637',
      },
      {
        id: "PG",
        value: 41114902,
        tooltip: '<span style="font-weight:bold;">Papua New Guinea</span><br />Population : 41114902',
      },
      {
        id: "PY",
        value: 33548798,
        tooltip: '<span style="font-weight:bold;">Paraguay</span><br />Population : 33548798',
      },
      {
        id: "NL",
        value: 35276260,
        tooltip: '<span style="font-weight:bold;">Netherlands</span><br />Population : 35276260',
      },
      {
        id: "PE",
        value: 35446265,
        tooltip: '<span style="font-weight:bold;">Peru</span><br />Population : 35446265',
      },
      {
        id: "PH",
        value: 34322043,
        tooltip: '<span style="font-weight:bold;">Philippines</span><br />Population : 34322043',
      },
      {
        id: "PL",
        value: 45620929,
        tooltip: '<span style="font-weight:bold;">Poland</span><br />Population : 45620929',
      },
      {
        id: "PT",
        value: 52057328,
        tooltip: '<span style="font-weight:bold;">Portugal</span><br />Population : 52057328',
      },
      {
        id: "QA",
        value: 11426306,
        tooltip: '<span style="font-weight:bold;">Qatar</span><br />Population : 11426306',
      },
      {
        id: "DO",
        value: 40515317,
        tooltip: '<span style="font-weight:bold;">Dominican Republic</span><br />Population : 40515317',
      },
      {
        id: "RO",
        value: 35581537,
        tooltip: '<span style="font-weight:bold;">Romania</span><br />Population : 35581537',
      },
      {
        id: "GB",
        value: 54682340,
        tooltip: '<span style="font-weight:bold;">United Kingdom</span><br />Population : 54682340',
      },
      {
        id: "RU",
        value: 1796386,
        tooltip: '<span style="font-weight:bold;">Russian Federation</span><br />Population : 1796386',
      },
      {
        id: "RW",
        value: 57822849,
        tooltip: '<span style="font-weight:bold;">Rwanda</span><br />Population : 57822849',
      },
      {
        id: "KN",
        value: 38996246,
        tooltip: '<span style="font-weight:bold;">Saint Kitts And Nevis</span><br />Population : 38996246',
      },
      {
        id: "SM",
        value: 26304422,
        tooltip: '<span style="font-weight:bold;">San Marino</span><br />Population : 26304422',
      },
      {
        id: "VC",
        value: 27147131,
        tooltip: '<span style="font-weight:bold;">Saint Vincent And The Grenadines</span><br />Population : 27147131',
      },
      {
        id: "LC",
        value: 54422763,
        tooltip: '<span style="font-weight:bold;">Saint Lucia</span><br />Population : 54422763',
      },
      {
        id: "SV",
        value: 1580682,
        tooltip: '<span style="font-weight:bold;">El Salvador</span><br />Population : 1580682',
      },
      {
        id: "WS",
        value: 39926700,
        tooltip: '<span style="font-weight:bold;">Samoa</span><br />Population : 39926700',
      },
      {
        id: "ST",
        value: 18219165,
        tooltip: '<span style="font-weight:bold;">Sao Tome And Principe</span><br />Population : 18219165',
      },
      {
        id: "SN",
        value: 28443185,
        tooltip: '<span style="font-weight:bold;">Senegal</span><br />Population : 28443185',
      },
      {
        id: "RS",
        value: 18800470,
        tooltip: '<span style="font-weight:bold;">Serbia</span><br />Population : 18800470',
      },
      {
        id: "SC",
        value: 18802298,
        tooltip: '<span style="font-weight:bold;">Seychelles</span><br />Population : 18802298',
      },
      {
        id: "SL",
        value: 55503113,
        tooltip: '<span style="font-weight:bold;">Sierra Leone</span><br />Population : 55503113',
      },
      {
        id: "SG",
        value: 7962240,
        tooltip: '<span style="font-weight:bold;">Singapore</span><br />Population : 7962240',
      },
      {
        id: "SK",
        value: 36371234,
        tooltip: '<span style="font-weight:bold;">Slovakia</span><br />Population : 36371234',
      },
      {
        id: "SI",
        value: 35934342,
        tooltip: '<span style="font-weight:bold;">Slovenia</span><br />Population : 35934342',
      },
      {
        id: "SO",
        value: 9839599,
        tooltip: '<span style="font-weight:bold;">Somalia</span><br />Population : 9839599',
      },
      {
        id: "SD",
        value: 51008054,
        tooltip: '<span style="font-weight:bold;">Sudan</span><br />Population : 51008054',
      },
      {
        id: "SS",
        value: 29958600,
        tooltip: '<span style="font-weight:bold;">South Sudan</span><br />Population : 29958600',
      },
      {
        id: "LK",
        value: 14575955,
        tooltip: '<span style="font-weight:bold;">Sri Lanka</span><br />Population : 14575955',
      },
      {
        id: "SE",
        value: 21619250,
        tooltip: '<span style="font-weight:bold;">Sweden</span><br />Population : 21619250',
      },
      {
        id: "CH",
        value: 5958749,
        tooltip: '<span style="font-weight:bold;">Switzerland</span><br />Population : 5958749',
      },
      {
        id: "SR",
        value: 5178192,
        tooltip: '<span style="font-weight:bold;">Suriname</span><br />Population : 5178192',
      },
      {
        id: "SZ",
        value: 27730264,
        tooltip: '<span style="font-weight:bold;">Swaziland</span><br />Population : 27730264',
      },
      {
        id: "SY",
        value: 21582690,
        tooltip: '<span style="font-weight:bold;">Syrian Arab Republic</span><br />Population : 21582690',
      },
      {
        id: "TJ",
        value: 50642453,
        tooltip: '<span style="font-weight:bold;">Tajikistan</span><br />Population : 50642453',
      },
      {
        id: "TZ",
        value: 57495636,
        tooltip: '<span style="font-weight:bold;">Tanzania, United Republic Of</span><br />Population : 57495636',
      },
      {
        id: "TD",
        value: 58550394,
        tooltip: '<span style="font-weight:bold;">Chad</span><br />Population : 58550394',
      },
      {
        id: "CZ",
        value: 30320544,
        tooltip: '<span style="font-weight:bold;">Czech Republic</span><br />Population : 30320544',
      },
      {
        id: "TH",
        value: 33437289,
        tooltip: '<span style="font-weight:bold;">Thailand</span><br />Population : 33437289',
      },
      {
        id: "TL",
        value: 12826556,
        tooltip: '<span style="font-weight:bold;">Timor-leste</span><br />Population : 12826556',
      },
      {
        id: "TG",
        value: 339468,
        tooltip: '<span style="font-weight:bold;">Togo</span><br />Population : 339468',
      },
      {
        id: "TO",
        value: 38473438,
        tooltip: '<span style="font-weight:bold;">Tonga</span><br />Population : 38473438',
      },
      {
        id: "TT",
        value: 12371383,
        tooltip: '<span style="font-weight:bold;">Trinidad And Tobago</span><br />Population : 12371383',
      },
      {
        id: "TN",
        value: 26536578,
        tooltip: '<span style="font-weight:bold;">Tunisia</span><br />Population : 26536578',
      },
      {
        id: "TM",
        value: 15950613,
        tooltip: '<span style="font-weight:bold;">Turkmenistan</span><br />Population : 15950613',
      },
      {
        id: "TR",
        value: 6731994,
        tooltip: '<span style="font-weight:bold;">Turkey</span><br />Population : 6731994',
      },
      {
        id: "TV",
        value: 15522860,
        tooltip: '<span style="font-weight:bold;">Tuvalu</span><br />Population : 15522860',
      },
      {
        id: "VU",
        value: 44341327,
        tooltip: '<span style="font-weight:bold;">Vanuatu</span><br />Population : 44341327',
      },
      {
        id: "VE",
        value: 58586954,
        tooltip: '<span style="font-weight:bold;">Venezuela, Bolivarian Republic Of</span><br />Population : 58586954',
      },
      {
        id: "VN",
        value: 45536841,
        tooltip: '<span style="font-weight:bold;">Viet Nam</span><br />Population : 45536841',
      },
      {
        id: "UA",
        value: 41019846,
        tooltip: '<span style="font-weight:bold;">Ukraine</span><br />Population : 41019846',
      },
      {
        id: "UY",
        value: 41906427,
        tooltip: '<span style="font-weight:bold;">Uruguay</span><br />Population : 41906427',
      },
      {
        id: "YE",
        value: 51501615,
        tooltip: '<span style="font-weight:bold;">Yemen</span><br />Population : 51501615',
      },
      {
        id: "ZM",
        value: 55678602,
        tooltip: '<span style="font-weight:bold;">Zambia</span><br />Population : 55678602',
      },
      {
        id: "ZW",
        value: 57040464,
        tooltip: '<span style="font-weight:bold;">Zimbabwe</span><br />Population : 57040464',
      },
    ],
  },
  2019: {
    areas: [
      {
        id: "AF",
        value: 30428397,
        tooltip: '<span style="font-weight:bold;">Afghanistan</span><br />Population : 30428397',
      },
      {
        id: "ZA",
        value: 42385364,
        tooltip: '<span style="font-weight:bold;">South Africa</span><br />Population : 42385364',
      },
      {
        id: "AL",
        value: 23215097,
        tooltip: '<span style="font-weight:bold;">Albania</span><br />Population : 23215097',
      },
      {
        id: "DZ",
        value: 59170087,
        tooltip: '<span style="font-weight:bold;">Algeria</span><br />Population : 59170087',
      },
      {
        id: "DE",
        value: 12696768,
        tooltip: '<span style="font-weight:bold;">Germany</span><br />Population : 12696768',
      },
      {
        id: "AD",
        value: 30181616,
        tooltip: '<span style="font-weight:bold;">Andorra</span><br />Population : 30181616',
      },
      {
        id: "AO",
        value: 59475364,
        tooltip: '<span style="font-weight:bold;">Angola</span><br />Population : 59475364',
      },
      {
        id: "AG",
        value: 31932843,
        tooltip: '<span style="font-weight:bold;">Antigua And Barbuda</span><br />Population : 31932843',
      },
      {
        id: "SA",
        value: 57555961,
        tooltip: '<span style="font-weight:bold;">Saudi Arabia</span><br />Population : 57555961',
      },
      {
        id: "AR",
        value: 11777282,
        tooltip: '<span style="font-weight:bold;">Argentina</span><br />Population : 11777282',
      },
      {
        id: "AM",
        value: 18871762,
        tooltip: '<span style="font-weight:bold;">Armenia</span><br />Population : 18871762',
      },
      {
        id: "AU",
        value: 12534076,
        tooltip: '<span style="font-weight:bold;">Australia</span><br />Population : 12534076',
      },
      {
        id: "AT",
        value: 58309098,
        tooltip: '<span style="font-weight:bold;">Austria</span><br />Population : 58309098',
      },
      {
        id: "AZ",
        value: 37712988,
        tooltip: '<span style="font-weight:bold;">Azerbaijan</span><br />Population : 37712988',
      },
      {
        id: "BS",
        value: 19332419,
        tooltip: '<span style="font-weight:bold;">Bahamas</span><br />Population : 19332419',
      },
      {
        id: "BH",
        value: 36539411,
        tooltip: '<span style="font-weight:bold;">Bahrain</span><br />Population : 36539411',
      },
      {
        id: "BD",
        value: 58009305,
        tooltip: '<span style="font-weight:bold;">Bangladesh</span><br />Population : 58009305',
      },
      {
        id: "BB",
        value: 8779358,
        tooltip: '<span style="font-weight:bold;">Barbados</span><br />Population : 8779358',
      },
      {
        id: "BE",
        value: 29035458,
        tooltip: '<span style="font-weight:bold;">Belgium</span><br />Population : 29035458',
      },
      {
        id: "BZ",
        value: 49664472,
        tooltip: '<span style="font-weight:bold;">Belize</span><br />Population : 49664472',
      },
      {
        id: "BJ",
        value: 9859707,
        tooltip: '<span style="font-weight:bold;">Benin</span><br />Population : 9859707',
      },
      {
        id: "BT",
        value: 35417017,
        tooltip: '<span style="font-weight:bold;">Bhutan</span><br />Population : 35417017',
      },
      {
        id: "BY",
        value: 46109006,
        tooltip: '<span style="font-weight:bold;">Belarus</span><br />Population : 46109006',
      },
      {
        id: "MM",
        value: 27574884,
        tooltip: '<span style="font-weight:bold;">Myanmar</span><br />Population : 27574884',
      },
      {
        id: "BO",
        value: 16813431,
        tooltip: '<span style="font-weight:bold;">Bolivia, Plurinational State Of</span><br />Population : 16813431',
      },
      {
        id: "BA",
        value: 18416589,
        tooltip: '<span style="font-weight:bold;">Bosnia And Herzegovina</span><br />Population : 18416589',
      },
      {
        id: "BW",
        value: 38731186,
        tooltip: '<span style="font-weight:bold;">Botswana</span><br />Population : 38731186',
      },
      {
        id: "BR",
        value: 35786273,
        tooltip: '<span style="font-weight:bold;">Brazil</span><br />Population : 35786273',
      },
      {
        id: "BN",
        value: 32073599,
        tooltip: '<span style="font-weight:bold;">Brunei Darussalam</span><br />Population : 32073599',
      },
      {
        id: "BG",
        value: 8318701,
        tooltip: '<span style="font-weight:bold;">Bulgaria</span><br />Population : 8318701',
      },
      {
        id: "BF",
        value: 5030123,
        tooltip: '<span style="font-weight:bold;">Burkina Faso</span><br />Population : 5030123',
      },
      {
        id: "BI",
        value: 49964264,
        tooltip: '<span style="font-weight:bold;">Burundi</span><br />Population : 49964264',
      },
      {
        id: "KH",
        value: 38793338,
        tooltip: '<span style="font-weight:bold;">Cambodia</span><br />Population : 38793338',
      },
      {
        id: "CM",
        value: 25713977,
        tooltip: '<span style="font-weight:bold;">Cameroon</span><br />Population : 25713977',
      },
      {
        id: "CA",
        value: 32983945,
        tooltip: '<span style="font-weight:bold;">Canada</span><br />Population : 32983945',
      },
      {
        id: "CV",
        value: 15824481,
        tooltip: '<span style="font-weight:bold;">Cape Verde</span><br />Population : 15824481',
      },
      {
        id: "CF",
        value: 50075772,
        tooltip: '<span style="font-weight:bold;">Central African Republic</span><br />Population : 50075772',
      },
      {
        id: "CL",
        value: 1343042,
        tooltip: '<span style="font-weight:bold;">Chile</span><br />Population : 1343042',
      },
      {
        id: "CN",
        value: 920773,
        tooltip: '<span style="font-weight:bold;">China</span><br />Population : 920773',
      },
      {
        id: "CY",
        value: 28832550,
        tooltip: '<span style="font-weight:bold;">Cyprus</span><br />Population : 28832550',
      },
      {
        id: "CO",
        value: 49074027,
        tooltip: '<span style="font-weight:bold;">Colombia</span><br />Population : 49074027',
      },
      {
        id: "KM",
        value: 15696521,
        tooltip: '<span style="font-weight:bold;">Comoros</span><br />Population : 15696521',
      },
      {
        id: "CG",
        value: 56718735,
        tooltip: '<span style="font-weight:bold;">Congo</span><br />Population : 56718735',
      },
      {
        id: "CD",
        value: 34704096,
        tooltip: '<span style="font-weight:bold;">Congo, The Democratic Republic Of The</span><br />Population : 34704096',
      },
      {
        id: "KP",
        value: 48891227,
        tooltip: "<span style=\"font-weight:bold;\">Korea, Democratic People's Republic Of</span><br />Population : 48891227",
      },
      {
        id: "KR",
        value: 59415040,
        tooltip: '<span style="font-weight:bold;">Korea, Republic Of</span><br />Population : 59415040',
      },
      {
        id: "CR",
        value: 18805954,
        tooltip: '<span style="font-weight:bold;">Costa Rica</span><br />Population : 18805954',
      },
      {
        id: "CI",
        value: 9104742,
        tooltip: "<span style=\"font-weight:bold;\">C\u00d4te D'ivoire</span><br />Population : 9104742",
      },
      {
        id: "HR",
        value: 32680496,
        tooltip: '<span style="font-weight:bold;">Croatia</span><br />Population : 32680496',
      },
      {
        id: "CU",
        value: 33289221,
        tooltip: '<span style="font-weight:bold;">Cuba</span><br />Population : 33289221',
      },
      {
        id: "DK",
        value: 35060556,
        tooltip: '<span style="font-weight:bold;">Denmark</span><br />Population : 35060556',
      },
      {
        id: "DJ",
        value: 17550116,
        tooltip: '<span style="font-weight:bold;">Djibouti</span><br />Population : 17550116',
      },
      {
        id: "DM",
        value: 13544961,
        tooltip: '<span style="font-weight:bold;">Dominica</span><br />Population : 13544961',
      },
      {
        id: "EG",
        value: 47759693,
        tooltip: '<span style="font-weight:bold;">Egypt</span><br />Population : 47759693',
      },
      {
        id: "AE",
        value: 43710666,
        tooltip: '<span style="font-weight:bold;">United Arab Emirates</span><br />Population : 43710666',
      },
      {
        id: "EC",
        value: 35705841,
        tooltip: '<span style="font-weight:bold;">Ecuador</span><br />Population : 35705841',
      },
      {
        id: "ER",
        value: 34537747,
        tooltip: '<span style="font-weight:bold;">Eritrea</span><br />Population : 34537747',
      },
      {
        id: "ES",
        value: 3617077,
        tooltip: '<span style="font-weight:bold;">Spain</span><br />Population : 3617077',
      },
      {
        id: "EE",
        value: 12934408,
        tooltip: '<span style="font-weight:bold;">Estonia</span><br />Population : 12934408',
      },
      {
        id: "US",
        value: 9287542,
        tooltip: '<span style="font-weight:bold;">United States</span><br />Population : 9287542',
      },
      {
        id: "ET",
        value: 48861978,
        tooltip: '<span style="font-weight:bold;">Ethiopia</span><br />Population : 48861978',
      },
      {
        id: "FJ",
        value: 11302002,
        tooltip: '<span style="font-weight:bold;">Fiji</span><br />Population : 11302002',
      },
      {
        id: "FI",
        value: 759909,
        tooltip: '<span style="font-weight:bold;">Finland</span><br />Population : 759909',
      },
      {
        id: "FR",
        value: 33760846,
        tooltip: '<span style="font-weight:bold;">France</span><br />Population : 33760846',
      },
      {
        id: "GA",
        value: 39670780,
        tooltip: '<span style="font-weight:bold;">Gabon</span><br />Population : 39670780',
      },
      {
        id: "GM",
        value: 31505090,
        tooltip: '<span style="font-weight:bold;">Gambia</span><br />Population : 31505090',
      },
      {
        id: "GE",
        value: 35265292,
        tooltip: '<span style="font-weight:bold;">Georgia</span><br />Population : 35265292',
      },
      {
        id: "GH",
        value: 54841376,
        tooltip: '<span style="font-weight:bold;">Ghana</span><br />Population : 54841376',
      },
      {
        id: "GR",
        value: 20067276,
        tooltip: '<span style="font-weight:bold;">Greece</span><br />Population : 20067276',
      },
      {
        id: "GD",
        value: 54866968,
        tooltip: '<span style="font-weight:bold;">Grenada</span><br />Population : 54866968',
      },
      {
        id: "GT",
        value: 54678684,
        tooltip: '<span style="font-weight:bold;">Guatemala</span><br />Population : 54678684',
      },
      {
        id: "GN",
        value: 48194757,
        tooltip: '<span style="font-weight:bold;">Guinea</span><br />Population : 48194757',
      },
      {
        id: "GQ",
        value: 33104593,
        tooltip: '<span style="font-weight:bold;">Equatorial Guinea</span><br />Population : 33104593',
      },
      {
        id: "GW",
        value: 42078259,
        tooltip: '<span style="font-weight:bold;">Guinea-bissau</span><br />Population : 42078259',
      },
      {
        id: "GY",
        value: 27178207,
        tooltip: '<span style="font-weight:bold;">Guyana</span><br />Population : 27178207',
      },
      {
        id: "HT",
        value: 19436615,
        tooltip: '<span style="font-weight:bold;">Haiti</span><br />Population : 19436615',
      },
      {
        id: "HN",
        value: 31985855,
        tooltip: '<span style="font-weight:bold;">Honduras</span><br />Population : 31985855',
      },
      {
        id: "HU",
        value: 43679590,
        tooltip: '<span style="font-weight:bold;">Hungary</span><br />Population : 43679590',
      },
      {
        id: "JM",
        value: 10791989,
        tooltip: '<span style="font-weight:bold;">Jamaica</span><br />Population : 10791989',
      },
      {
        id: "JP",
        value: 4132574,
        tooltip: '<span style="font-weight:bold;">Japan</span><br />Population : 4132574',
      },
      {
        id: "MH",
        value: 59764188,
        tooltip: '<span style="font-weight:bold;">Marshall Islands</span><br />Population : 59764188',
      },
      {
        id: "PW",
        value: 20361584,
        tooltip: '<span style="font-weight:bold;">Palau</span><br />Population : 20361584',
      },
      {
        id: "SB",
        value: 33598154,
        tooltip: '<span style="font-weight:bold;">Solomon Islands</span><br />Population : 33598154',
      },
      {
        id: "IN",
        value: 7898260,
        tooltip: '<span style="font-weight:bold;">India</span><br />Population : 7898260',
      },
      {
        id: "ID",
        value: 9742715,
        tooltip: '<span style="font-weight:bold;">Indonesia</span><br />Population : 9742715',
      },
      {
        id: "JO",
        value: 22664868,
        tooltip: '<span style="font-weight:bold;">Jordan</span><br />Population : 22664868',
      },
      {
        id: "IR",
        value: 33824826,
        tooltip: '<span style="font-weight:bold;">Iran, Islamic Republic Of</span><br />Population : 33824826',
      },
      {
        id: "IQ",
        value: 6399298,
        tooltip: '<span style="font-weight:bold;">Iraq</span><br />Population : 6399298',
      },
      {
        id: "IE",
        value: 44774564,
        tooltip: '<span style="font-weight:bold;">Ireland</span><br />Population : 44774564',
      },
      {
        id: "IS",
        value: 11280066,
        tooltip: '<span style="font-weight:bold;">Iceland</span><br />Population : 11280066',
      },
      {
        id: "IL",
        value: 39550131,
        tooltip: '<span style="font-weight:bold;">Israel</span><br />Population : 39550131',
      },
      {
        id: "IT",
        value: 5251312,
        tooltip: '<span style="font-weight:bold;">Italy</span><br />Population : 5251312',
      },
      {
        id: "KZ",
        value: 58162858,
        tooltip: '<span style="font-weight:bold;">Kazakhstan</span><br />Population : 58162858',
      },
      {
        id: "KE",
        value: 36747803,
        tooltip: '<span style="font-weight:bold;">Kenya</span><br />Population : 36747803',
      },
      {
        id: "KG",
        value: 48902195,
        tooltip: '<span style="font-weight:bold;">Kyrgyzstan</span><br />Population : 48902195',
      },
      {
        id: "KI",
        value: 40019928,
        tooltip: '<span style="font-weight:bold;">Kiribati</span><br />Population : 40019928',
      },
      {
        id: "KW",
        value: 33060721,
        tooltip: '<span style="font-weight:bold;">Kuwait</span><br />Population : 33060721',
      },
      {
        id: "LA",
        value: 59758704,
        tooltip: "<span style=\"font-weight:bold;\">Lao People's Democratic Republic</span><br />Population : 59758704",
      },
      {
        id: "LS",
        value: 30059140,
        tooltip: '<span style="font-weight:bold;">Lesotho</span><br />Population : 30059140',
      },
      {
        id: "LV",
        value: 56420771,
        tooltip: '<span style="font-weight:bold;">Latvia</span><br />Population : 56420771',
      },
      {
        id: "LB",
        value: 42471280,
        tooltip: '<span style="font-weight:bold;">Lebanon</span><br />Population : 42471280',
      },
      {
        id: "LR",
        value: 11053393,
        tooltip: '<span style="font-weight:bold;">Liberia</span><br />Population : 11053393',
      },
      {
        id: "LY",
        value: 41049094,
        tooltip: '<span style="font-weight:bold;">Libya</span><br />Population : 41049094',
      },
      {
        id: "LI",
        value: 30119464,
        tooltip: '<span style="font-weight:bold;">Liechtenstein</span><br />Population : 30119464',
      },
      {
        id: "LT",
        value: 9647659,
        tooltip: '<span style="font-weight:bold;">Lithuania</span><br />Population : 9647659',
      },
      {
        id: "LU",
        value: 31022498,
        tooltip: '<span style="font-weight:bold;">Luxembourg</span><br />Population : 31022498',
      },
      {
        id: "MK",
        value: 50050180,
        tooltip: '<span style="font-weight:bold;">Macedonia, The Former Yugoslav Republic Of</span><br />Population : 50050180',
      },
      {
        id: "MG",
        value: 26631634,
        tooltip: '<span style="font-weight:bold;">Madagascar</span><br />Population : 26631634',
      },
      {
        id: "MY",
        value: 7592984,
        tooltip: '<span style="font-weight:bold;">Malaysia</span><br />Population : 7592984',
      },
      {
        id: "MW",
        value: 50406641,
        tooltip: '<span style="font-weight:bold;">Malawi</span><br />Population : 50406641',
      },
      {
        id: "MV",
        value: 55190525,
        tooltip: '<span style="font-weight:bold;">Maldives</span><br />Population : 55190525',
      },
      {
        id: "ML",
        value: 21622906,
        tooltip: '<span style="font-weight:bold;">Mali</span><br />Population : 21622906',
      },
      {
        id: "MT",
        value: 19460379,
        tooltip: '<span style="font-weight:bold;">Malta</span><br />Population : 19460379',
      },
      {
        id: "MA",
        value: 29896448,
        tooltip: '<span style="font-weight:bold;">Morocco</span><br />Population : 29896448',
      },
      {
        id: "MU",
        value: 24648251,
        tooltip: '<span style="font-weight:bold;">Mauritius</span><br />Population : 24648251',
      },
      {
        id: "MR",
        value: 20708905,
        tooltip: '<span style="font-weight:bold;">Mauritania</span><br />Population : 20708905',
      },
      {
        id: "MX",
        value: 58352970,
        tooltip: '<span style="font-weight:bold;">Mexico</span><br />Population : 58352970',
      },
      {
        id: "FM",
        value: 20032544,
        tooltip: '<span style="font-weight:bold;">Micronesia, Federated States Of</span><br />Population : 20032544',
      },
      {
        id: "MD",
        value: 16451486,
        tooltip: '<span style="font-weight:bold;">Moldova, Republic Of</span><br />Population : 16451486',
      },
      {
        id: "MC",
        value: 59455256,
        tooltip: '<span style="font-weight:bold;">Monaco</span><br />Population : 59455256',
      },
      {
        id: "MN",
        value: 47523880,
        tooltip: '<span style="font-weight:bold;">Mongolia</span><br />Population : 47523880',
      },
      {
        id: "ME",
        value: 41405554,
        tooltip: '<span style="font-weight:bold;">Montenegro</span><br />Population : 41405554',
      },
      {
        id: "MZ",
        value: 58678354,
        tooltip: '<span style="font-weight:bold;">Mozambique</span><br />Population : 58678354',
      },
      {
        id: "NA",
        value: 23677582,
        tooltip: '<span style="font-weight:bold;">Namibia</span><br />Population : 23677582',
      },
      {
        id: "NP",
        value: 59976236,
        tooltip: '<span style="font-weight:bold;">Nepal</span><br />Population : 59976236',
      },
      {
        id: "NI",
        value: 24756103,
        tooltip: '<span style="font-weight:bold;">Nicaragua</span><br />Population : 24756103',
      },
      {
        id: "NE",
        value: 29656979,
        tooltip: '<span style="font-weight:bold;">Niger</span><br />Population : 29656979',
      },
      {
        id: "NG",
        value: 8841510,
        tooltip: '<span style="font-weight:bold;">Nigeria</span><br />Population : 8841510',
      },
      {
        id: "NO",
        value: 18963162,
        tooltip: '<span style="font-weight:bold;">Norway</span><br />Population : 18963162',
      },
      {
        id: "NZ",
        value: 50574817,
        tooltip: '<span style="font-weight:bold;">New Zealand</span><br />Population : 50574817',
      },
      {
        id: "OM",
        value: 17365487,
        tooltip: '<span style="font-weight:bold;">Oman</span><br />Population : 17365487',
      },
      {
        id: "UG",
        value: 20562665,
        tooltip: '<span style="font-weight:bold;">Uganda</span><br />Population : 20562665',
      },
      {
        id: "UZ",
        value: 57387784,
        tooltip: '<span style="font-weight:bold;">Uzbekistan</span><br />Population : 57387784',
      },
      {
        id: "PK",
        value: 49602320,
        tooltip: '<span style="font-weight:bold;">Pakistan</span><br />Population : 49602320',
      },
      {
        id: "PS",
        value: 19932004,
        tooltip: '<span style="font-weight:bold;">Palestine, State Of</span><br />Population : 19932004',
      },
      {
        id: "PA",
        value: 34506671,
        tooltip: '<span style="font-weight:bold;">Panama</span><br />Population : 34506671',
      },
      {
        id: "PG",
        value: 38603226,
        tooltip: '<span style="font-weight:bold;">Papua New Guinea</span><br />Population : 38603226',
      },
      {
        id: "PY",
        value: 42429236,
        tooltip: '<span style="font-weight:bold;">Paraguay</span><br />Population : 42429236',
      },
      {
        id: "NL",
        value: 5534652,
        tooltip: '<span style="font-weight:bold;">Netherlands</span><br />Population : 5534652',
      },
      {
        id: "PE",
        value: 56289154,
        tooltip: '<span style="font-weight:bold;">Peru</span><br />Population : 56289154',
      },
      {
        id: "PH",
        value: 35612613,
        tooltip: '<span style="font-weight:bold;">Philippines</span><br />Population : 35612613',
      },
      {
        id: "PL",
        value: 19696191,
        tooltip: '<span style="font-weight:bold;">Poland</span><br />Population : 19696191',
      },
      {
        id: "PT",
        value: 32201559,
        tooltip: '<span style="font-weight:bold;">Portugal</span><br />Population : 32201559',
      },
      {
        id: "QA",
        value: 1675738,
        tooltip: '<span style="font-weight:bold;">Qatar</span><br />Population : 1675738',
      },
      {
        id: "DO",
        value: 31569070,
        tooltip: '<span style="font-weight:bold;">Dominican Republic</span><br />Population : 31569070',
      },
      {
        id: "RO",
        value: 1993811,
        tooltip: '<span style="font-weight:bold;">Romania</span><br />Population : 1993811',
      },
      {
        id: "GB",
        value: 8210849,
        tooltip: '<span style="font-weight:bold;">United Kingdom</span><br />Population : 8210849',
      },
      {
        id: "RU",
        value: 55982050,
        tooltip: '<span style="font-weight:bold;">Russian Federation</span><br />Population : 55982050',
      },
      {
        id: "RW",
        value: 39575723,
        tooltip: '<span style="font-weight:bold;">Rwanda</span><br />Population : 39575723',
      },
      {
        id: "KN",
        value: 39862720,
        tooltip: '<span style="font-weight:bold;">Saint Kitts And Nevis</span><br />Population : 39862720',
      },
      {
        id: "SM",
        value: 51490647,
        tooltip: '<span style="font-weight:bold;">San Marino</span><br />Population : 51490647',
      },
      {
        id: "VC",
        value: 15173712,
        tooltip: '<span style="font-weight:bold;">Saint Vincent And The Grenadines</span><br />Population : 15173712',
      },
      {
        id: "LC",
        value: 42785697,
        tooltip: '<span style="font-weight:bold;">Saint Lucia</span><br />Population : 42785697',
      },
      {
        id: "SV",
        value: 34093543,
        tooltip: '<span style="font-weight:bold;">El Salvador</span><br />Population : 34093543',
      },
      {
        id: "WS",
        value: 10419076,
        tooltip: '<span style="font-weight:bold;">Samoa</span><br />Population : 10419076',
      },
      {
        id: "ST",
        value: 4666351,
        tooltip: '<span style="font-weight:bold;">Sao Tome And Principe</span><br />Population : 4666351',
      },
      {
        id: "SN",
        value: 54302115,
        tooltip: '<span style="font-weight:bold;">Senegal</span><br />Population : 54302115',
      },
      {
        id: "RS",
        value: 35226904,
        tooltip: '<span style="font-weight:bold;">Serbia</span><br />Population : 35226904',
      },
      {
        id: "SC",
        value: 2924264,
        tooltip: '<span style="font-weight:bold;">Seychelles</span><br />Population : 2924264',
      },
      {
        id: "SL",
        value: 125592,
        tooltip: '<span style="font-weight:bold;">Sierra Leone</span><br />Population : 125592',
      },
      {
        id: "SG",
        value: 57278104,
        tooltip: '<span style="font-weight:bold;">Singapore</span><br />Population : 57278104',
      },
      {
        id: "SK",
        value: 3953430,
        tooltip: '<span style="font-weight:bold;">Slovakia</span><br />Population : 3953430',
      },
      {
        id: "SI",
        value: 57084336,
        tooltip: '<span style="font-weight:bold;">Slovenia</span><br />Population : 57084336',
      },
      {
        id: "SO",
        value: 7167059,
        tooltip: '<span style="font-weight:bold;">Somalia</span><br />Population : 7167059',
      },
      {
        id: "SD",
        value: 4916787,
        tooltip: '<span style="font-weight:bold;">Sudan</span><br />Population : 4916787',
      },
      {
        id: "SS",
        value: 50713745,
        tooltip: '<span style="font-weight:bold;">South Sudan</span><br />Population : 50713745',
      },
      {
        id: "LK",
        value: 51227414,
        tooltip: '<span style="font-weight:bold;">Sri Lanka</span><br />Population : 51227414',
      },
      {
        id: "SE",
        value: 1456378,
        tooltip: '<span style="font-weight:bold;">Sweden</span><br />Population : 1456378',
      },
      {
        id: "CH",
        value: 171292,
        tooltip: '<span style="font-weight:bold;">Switzerland</span><br />Population : 171292',
      },
      {
        id: "SR",
        value: 16398474,
        tooltip: '<span style="font-weight:bold;">Suriname</span><br />Population : 16398474',
      },
      {
        id: "SZ",
        value: 13431625,
        tooltip: '<span style="font-weight:bold;">Swaziland</span><br />Population : 13431625',
      },
      {
        id: "SY",
        value: 48509174,
        tooltip: '<span style="font-weight:bold;">Syrian Arab Republic</span><br />Population : 48509174',
      },
      {
        id: "TJ",
        value: 56144742,
        tooltip: '<span style="font-weight:bold;">Tajikistan</span><br />Population : 56144742',
      },
      {
        id: "TZ",
        value: 11448242,
        tooltip: '<span style="font-weight:bold;">Tanzania, United Republic Of</span><br />Population : 11448242',
      },
      {
        id: "TD",
        value: 1725094,
        tooltip: '<span style="font-weight:bold;">Chad</span><br />Population : 1725094',
      },
      {
        id: "CZ",
        value: 4191070,
        tooltip: '<span style="font-weight:bold;">Czech Republic</span><br />Population : 4191070',
      },
      {
        id: "TH",
        value: 36190262,
        tooltip: '<span style="font-weight:bold;">Thailand</span><br />Population : 36190262',
      },
      {
        id: "TL",
        value: 56453675,
        tooltip: '<span style="font-weight:bold;">Timor-leste</span><br />Population : 56453675',
      },
      {
        id: "TG",
        value: 44185947,
        tooltip: '<span style="font-weight:bold;">Togo</span><br />Population : 44185947',
      },
      {
        id: "TO",
        value: 53817694,
        tooltip: '<span style="font-weight:bold;">Tonga</span><br />Population : 53817694',
      },
      {
        id: "TT",
        value: 13310977,
        tooltip: '<span style="font-weight:bold;">Trinidad And Tobago</span><br />Population : 13310977',
      },
      {
        id: "TN",
        value: 22255395,
        tooltip: '<span style="font-weight:bold;">Tunisia</span><br />Population : 22255395',
      },
      {
        id: "TM",
        value: 19142306,
        tooltip: '<span style="font-weight:bold;">Turkmenistan</span><br />Population : 19142306',
      },
      {
        id: "TR",
        value: 53254670,
        tooltip: '<span style="font-weight:bold;">Turkey</span><br />Population : 53254670',
      },
      {
        id: "TV",
        value: 30560013,
        tooltip: '<span style="font-weight:bold;">Tuvalu</span><br />Population : 30560013',
      },
      {
        id: "VU",
        value: 49244031,
        tooltip: '<span style="font-weight:bold;">Vanuatu</span><br />Population : 49244031',
      },
      {
        id: "VE",
        value: 14572299,
        tooltip: '<span style="font-weight:bold;">Venezuela, Bolivarian Republic Of</span><br />Population : 14572299',
      },
      {
        id: "VN",
        value: 8117620,
        tooltip: '<span style="font-weight:bold;">Viet Nam</span><br />Population : 8117620',
      },
      {
        id: "UA",
        value: 41140494,
        tooltip: '<span style="font-weight:bold;">Ukraine</span><br />Population : 41140494',
      },
      {
        id: "UY",
        value: 8260205,
        tooltip: '<span style="font-weight:bold;">Uruguay</span><br />Population : 8260205',
      },
      {
        id: "YE",
        value: 28604050,
        tooltip: '<span style="font-weight:bold;">Yemen</span><br />Population : 28604050',
      },
      {
        id: "ZM",
        value: 13872174,
        tooltip: '<span style="font-weight:bold;">Zambia</span><br />Population : 13872174',
      },
      {
        id: "ZW",
        value: 28205545,
        tooltip: '<span style="font-weight:bold;">Zimbabwe</span><br />Population : 28205545',
      },
    ],
  },
};
